/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActRequest,
  AddressListRequest,
  AdvanceRequest,
  ApplicationProfileRequest,
  ApprovalSettings,
  BankInputRequest,
  BulkBatchDetail,
  BulkBatchPage,
  BulkCategoryChoice,
  BulkImportRequestRequest,
  BulkRowPage,
  BulkUploadRequest,
  CancelRequest,
  CategoriesInputRequest,
  DocumentInputRequest,
  Export,
  ExportRequestRequest,
  Folder,
  FolderWriteRequest,
  FormSchema,
  InstalledModule,
  MarkedRead,
  MediaDetail,
  Notification,
  OpenRequest,
  Overview,
  PaginatedEntryList,
  PaginatedInvoiceList,
  PaginatedMediaList,
  PaginatedNotificationList,
  PaginatedPayoutList,
  PaginatedProductListList,
  PaginatedReturnListList,
  PaginatedStockRowList,
  PaginatedStoreActivityList,
  PaginatedTicketListList,
  PaginatedVendorOrderListList,
  PatchedApplicationProfileRequest,
  PatchedFolderWriteRequest,
  PatchedMediaUpdateRequest,
  PatchedProductWriteRequest,
  PatchedProfileUpdateRequest,
  PatchedStockChangeRequest,
  PatchedStoreUpdateRequest,
  PatchedTeamMemberUpdateRequest,
  PayoutDetail,
  PhoneCodeRequest,
  ProductDetail,
  ProductHistory,
  ProductStatusCounts,
  ProductWriteRequest,
  ReplyRequest,
  ReturnCounts,
  ReturnDetail,
  StatusCounts,
  StockBulkRequest,
  StockBulkResult,
  StockImportRequest,
  StockImportResult,
  StockMovement,
  StockRow,
  StockSummary,
  StoreActivity,
  StoreAddress,
  StoreAddressInputRequest,
  StoreBankInputRequest,
  StoreBrand,
  StoreOnlineRequest,
  StoreSettings,
  StoreSummary,
  Summary,
  TaxClassRef,
  TaxDeductionSummary,
  TaxIdsInputRequest,
  TeamInviteRequest,
  TeamMember,
  TicketCategory,
  TicketDetail,
  TrackingRequest,
  UnreadCount,
  UploadRequest,
  ValidateRequest,
  Validated,
  VendorActivityListParams,
  VendorApplication,
  VendorBankAccount,
  VendorBrandsListParams,
  VendorBulkPublishRequest,
  VendorBulkPublishResult,
  VendorBulkUploadBatchesListParams,
  VendorBulkUploadBatchesRowsListParams,
  VendorBulkUploadTemplateMacroRetrieveParams,
  VendorBulkUploadTemplateRetrieveParams,
  VendorBulkUploadUpdateSheetRetrieveParams,
  VendorCourier,
  VendorEarningsLedgerParams,
  VendorEarningsPayoutsParams,
  VendorEarningsTaxDeductionsParams,
  VendorFeaturesRetrieve200,
  VendorInvoicesListParams,
  VendorMe,
  VendorMediaDestroyParams,
  VendorMediaFileRetrieveParams,
  VendorMediaListParams,
  VendorMediaRetrieveParams,
  VendorNotificationsListParams,
  VendorOrderDetail,
  VendorOrdersListParams,
  VendorProductPublishRequest,
  VendorProductsListParams,
  VendorReportsOverviewParams,
  VendorReturnsListParams,
  VendorStockListParams,
  VendorTicketsListParams,
  VideoRequest
} from '../../model';

import { apiFetch } from '../../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type vendorActivityListResponse200 = {
  data: PaginatedStoreActivityList
  status: 200
}

export type vendorActivityListResponseSuccess = (vendorActivityListResponse200) & {
  headers: Headers;
};
;

export type vendorActivityListResponse = (vendorActivityListResponseSuccess)

export const getVendorActivityListUrl = (params?: VendorActivityListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/activity?${stringifiedParams}` : `/api/v1/vendor/activity`
}

/**
 * Newest first; cursor pagination (`?cursor=`).
 */
export const vendorActivityList = async (params?: VendorActivityListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorActivityListResponse> => {

  return apiFetch<vendorActivityListResponse>(getVendorActivityListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorActivityListQueryKey = (params?: VendorActivityListParams,) => {
    return [
    `/api/v1/vendor/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorActivityListQueryOptions = <TData = Awaited<ReturnType<typeof vendorActivityList>>, TError = unknown>(params?: VendorActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorActivityListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorActivityList>>> = ({ signal }) => vendorActivityList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorActivityList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorActivityListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorActivityList>>>
export type VendorActivityListQueryError = unknown


export function useVendorActivityList<TData = Awaited<ReturnType<typeof vendorActivityList>>, TError = unknown>(
 params: undefined |  VendorActivityListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorActivityList>>,
          TError,
          Awaited<ReturnType<typeof vendorActivityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorActivityList<TData = Awaited<ReturnType<typeof vendorActivityList>>, TError = unknown>(
 params?: VendorActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorActivityList>>,
          TError,
          Awaited<ReturnType<typeof vendorActivityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorActivityList<TData = Awaited<ReturnType<typeof vendorActivityList>>, TError = unknown>(
 params?: VendorActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorActivityList<TData = Awaited<ReturnType<typeof vendorActivityList>>, TError = unknown>(
 params?: VendorActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorActivityListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorActivityRetrieveResponse200 = {
  data: StoreActivity
  status: 200
}

export type vendorActivityRetrieveResponseSuccess = (vendorActivityRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorActivityRetrieveResponse = (vendorActivityRetrieveResponseSuccess)

export const getVendorActivityRetrieveUrl = (uid: string,) => {




  return `/api/v1/vendor/activity/${uid}`
}

/**
 * Look objects up by public `uid` in URLs (`/vendors/<uid>`), never by integer id.
 */
export const vendorActivityRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorActivityRetrieveResponse> => {

  return apiFetch<vendorActivityRetrieveResponse>(getVendorActivityRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorActivityRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/activity/${uid}`
    ] as const;
    }


export const getVendorActivityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorActivityRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorActivityRetrieve>>> = ({ signal }) => vendorActivityRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorActivityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorActivityRetrieve>>>
export type VendorActivityRetrieveQueryError = unknown


export function useVendorActivityRetrieve<TData = Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorActivityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorActivityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorActivityRetrieve<TData = Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorActivityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorActivityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorActivityRetrieve<TData = Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorActivityRetrieve<TData = Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorActivityRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorActivityActionsListResponse200 = {
  data: string[]
  status: 200
}

export type vendorActivityActionsListResponseSuccess = (vendorActivityActionsListResponse200) & {
  headers: Headers;
};
;

export type vendorActivityActionsListResponse = (vendorActivityActionsListResponseSuccess)

export const getVendorActivityActionsListUrl = () => {




  return `/api/v1/vendor/activity/actions`
}

/**
 * Actions that occur in the store's log, for the filter dropdown.
 */
export const vendorActivityActionsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorActivityActionsListResponse> => {

  return apiFetch<vendorActivityActionsListResponse>(getVendorActivityActionsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorActivityActionsListQueryKey = () => {
    return [
    `/api/v1/vendor/activity/actions`
    ] as const;
    }


export const getVendorActivityActionsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorActivityActionsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityActionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorActivityActionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorActivityActionsList>>> = ({ signal }) => vendorActivityActionsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorActivityActionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorActivityActionsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorActivityActionsList>>>
export type VendorActivityActionsListQueryError = unknown


export function useVendorActivityActionsList<TData = Awaited<ReturnType<typeof vendorActivityActionsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityActionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorActivityActionsList>>,
          TError,
          Awaited<ReturnType<typeof vendorActivityActionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorActivityActionsList<TData = Awaited<ReturnType<typeof vendorActivityActionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityActionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorActivityActionsList>>,
          TError,
          Awaited<ReturnType<typeof vendorActivityActionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorActivityActionsList<TData = Awaited<ReturnType<typeof vendorActivityActionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityActionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorActivityActionsList<TData = Awaited<ReturnType<typeof vendorActivityActionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorActivityActionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorActivityActionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorApplicationRetrieveResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationRetrieveResponseSuccess = (vendorApplicationRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationRetrieveResponse = (vendorApplicationRetrieveResponseSuccess)

export const getVendorApplicationRetrieveUrl = () => {




  return `/api/v1/vendor/application`
}

export const vendorApplicationRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationRetrieveResponse> => {

  return apiFetch<vendorApplicationRetrieveResponse>(getVendorApplicationRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorApplicationRetrieveQueryKey = () => {
    return [
    `/api/v1/vendor/application`
    ] as const;
    }


export const getVendorApplicationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorApplicationRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorApplicationRetrieve>>> = ({ signal }) => vendorApplicationRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorApplicationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationRetrieve>>>
export type VendorApplicationRetrieveQueryError = unknown


export function useVendorApplicationRetrieve<TData = Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorApplicationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorApplicationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorApplicationRetrieve<TData = Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorApplicationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorApplicationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorApplicationRetrieve<TData = Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorApplicationRetrieve<TData = Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorApplicationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorApplicationRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorApplicationCreateResponse201 = {
  data: VendorApplication
  status: 201
}

export type vendorApplicationCreateResponseSuccess = (vendorApplicationCreateResponse201) & {
  headers: Headers;
};
;

export type vendorApplicationCreateResponse = (vendorApplicationCreateResponseSuccess)

export const getVendorApplicationCreateUrl = () => {




  return `/api/v1/vendor/application`
}

export const vendorApplicationCreate = async (applicationProfileRequest?: ApplicationProfileRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationCreateResponse>(getVendorApplicationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(applicationProfileRequest)
  }
);}





export const getVendorApplicationCreateMutationKey = () => ['vendorApplicationCreate'] as const;

export const getVendorApplicationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationCreate>>, TError,VendorApplicationCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationCreate>>, TError,VendorApplicationCreateMutationVariables, TContext> => {

const mutationKey = getVendorApplicationCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationCreate>>, VendorApplicationCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationCreate>>>
    export type VendorApplicationCreateMutationBody = ApplicationProfileRequest | undefined
    export type VendorApplicationCreateMutationError = unknown
    export type VendorApplicationCreateMutationVariables = {data?: ApplicationProfileRequest}

    export const useVendorApplicationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationCreate>>, TError,VendorApplicationCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationCreate>>,
        TError,
        VendorApplicationCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationCreateMutationOptions(options), queryClient);
    }
    export type vendorApplicationPartialUpdateResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationPartialUpdateResponseSuccess = (vendorApplicationPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationPartialUpdateResponse = (vendorApplicationPartialUpdateResponseSuccess)

export const getVendorApplicationPartialUpdateUrl = () => {




  return `/api/v1/vendor/application`
}

export const vendorApplicationPartialUpdate = async (patchedApplicationProfileRequest?: PatchedApplicationProfileRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationPartialUpdateResponse>(getVendorApplicationPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedApplicationProfileRequest)
  }
);}





export const getVendorApplicationPartialUpdateMutationKey = () => ['vendorApplicationPartialUpdate'] as const;

export const getVendorApplicationPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPartialUpdate>>, TError,VendorApplicationPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPartialUpdate>>, TError,VendorApplicationPartialUpdateMutationVariables, TContext> => {

const mutationKey = getVendorApplicationPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationPartialUpdate>>, VendorApplicationPartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationPartialUpdate>>>
    export type VendorApplicationPartialUpdateMutationBody = PatchedApplicationProfileRequest | undefined
    export type VendorApplicationPartialUpdateMutationError = unknown
    export type VendorApplicationPartialUpdateMutationVariables = {data?: PatchedApplicationProfileRequest}

    export const useVendorApplicationPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPartialUpdate>>, TError,VendorApplicationPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationPartialUpdate>>,
        TError,
        VendorApplicationPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationPartialUpdateMutationOptions(options), queryClient);
    }
    export type vendorApplicationAddressesResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationAddressesResponseSuccess = (vendorApplicationAddressesResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationAddressesResponse = (vendorApplicationAddressesResponseSuccess)

export const getVendorApplicationAddressesUrl = () => {




  return `/api/v1/vendor/application/addresses`
}

export const vendorApplicationAddresses = async (addressListRequest: AddressListRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationAddressesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationAddressesResponse>(getVendorApplicationAddressesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addressListRequest)
  }
);}





export const getVendorApplicationAddressesMutationKey = () => ['vendorApplicationAddresses'] as const;

export const getVendorApplicationAddressesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationAddresses>>, TError,VendorApplicationAddressesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationAddresses>>, TError,VendorApplicationAddressesMutationVariables, TContext> => {

const mutationKey = getVendorApplicationAddressesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationAddresses>>, VendorApplicationAddressesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationAddresses(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationAddressesMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationAddresses>>>
    export type VendorApplicationAddressesMutationBody = AddressListRequest
    export type VendorApplicationAddressesMutationError = unknown
    export type VendorApplicationAddressesMutationVariables = {data: AddressListRequest}

    export const useVendorApplicationAddresses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationAddresses>>, TError,VendorApplicationAddressesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationAddresses>>,
        TError,
        VendorApplicationAddressesMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationAddressesMutationOptions(options), queryClient);
    }
    export type vendorApplicationBankResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationBankResponseSuccess = (vendorApplicationBankResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationBankResponse = (vendorApplicationBankResponseSuccess)

export const getVendorApplicationBankUrl = () => {




  return `/api/v1/vendor/application/bank`
}

export const vendorApplicationBank = async (bankInputRequest: BankInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationBankResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationBankResponse>(getVendorApplicationBankUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bankInputRequest)
  }
);}





export const getVendorApplicationBankMutationKey = () => ['vendorApplicationBank'] as const;

export const getVendorApplicationBankMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationBank>>, TError,VendorApplicationBankMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationBank>>, TError,VendorApplicationBankMutationVariables, TContext> => {

const mutationKey = getVendorApplicationBankMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationBank>>, VendorApplicationBankMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationBank(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationBankMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationBank>>>
    export type VendorApplicationBankMutationBody = BankInputRequest
    export type VendorApplicationBankMutationError = unknown
    export type VendorApplicationBankMutationVariables = {data: BankInputRequest}

    export const useVendorApplicationBank = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationBank>>, TError,VendorApplicationBankMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationBank>>,
        TError,
        VendorApplicationBankMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationBankMutationOptions(options), queryClient);
    }
    export type vendorApplicationCategoriesResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationCategoriesResponseSuccess = (vendorApplicationCategoriesResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationCategoriesResponse = (vendorApplicationCategoriesResponseSuccess)

export const getVendorApplicationCategoriesUrl = () => {




  return `/api/v1/vendor/application/categories`
}

export const vendorApplicationCategories = async (categoriesInputRequest: CategoriesInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationCategoriesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationCategoriesResponse>(getVendorApplicationCategoriesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(categoriesInputRequest)
  }
);}





export const getVendorApplicationCategoriesMutationKey = () => ['vendorApplicationCategories'] as const;

export const getVendorApplicationCategoriesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationCategories>>, TError,VendorApplicationCategoriesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationCategories>>, TError,VendorApplicationCategoriesMutationVariables, TContext> => {

const mutationKey = getVendorApplicationCategoriesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationCategories>>, VendorApplicationCategoriesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationCategories(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationCategories>>>
    export type VendorApplicationCategoriesMutationBody = CategoriesInputRequest
    export type VendorApplicationCategoriesMutationError = unknown
    export type VendorApplicationCategoriesMutationVariables = {data: CategoriesInputRequest}

    export const useVendorApplicationCategories = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationCategories>>, TError,VendorApplicationCategoriesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationCategories>>,
        TError,
        VendorApplicationCategoriesMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationCategoriesMutationOptions(options), queryClient);
    }
    export type vendorApplicationDocumentsAddResponse201 = {
  data: VendorApplication
  status: 201
}

export type vendorApplicationDocumentsAddResponseSuccess = (vendorApplicationDocumentsAddResponse201) & {
  headers: Headers;
};
;

export type vendorApplicationDocumentsAddResponse = (vendorApplicationDocumentsAddResponseSuccess)

export const getVendorApplicationDocumentsAddUrl = () => {




  return `/api/v1/vendor/application/documents`
}

export const vendorApplicationDocumentsAdd = async (documentInputRequest: DocumentInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationDocumentsAddResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationDocumentsAddResponse>(getVendorApplicationDocumentsAddUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(documentInputRequest)
  }
);}





export const getVendorApplicationDocumentsAddMutationKey = () => ['vendorApplicationDocumentsAdd'] as const;

export const getVendorApplicationDocumentsAddMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationDocumentsAdd>>, TError,VendorApplicationDocumentsAddMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationDocumentsAdd>>, TError,VendorApplicationDocumentsAddMutationVariables, TContext> => {

const mutationKey = getVendorApplicationDocumentsAddMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationDocumentsAdd>>, VendorApplicationDocumentsAddMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationDocumentsAdd(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationDocumentsAddMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationDocumentsAdd>>>
    export type VendorApplicationDocumentsAddMutationBody = DocumentInputRequest
    export type VendorApplicationDocumentsAddMutationError = unknown
    export type VendorApplicationDocumentsAddMutationVariables = {data: DocumentInputRequest}

    export const useVendorApplicationDocumentsAdd = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationDocumentsAdd>>, TError,VendorApplicationDocumentsAddMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationDocumentsAdd>>,
        TError,
        VendorApplicationDocumentsAddMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationDocumentsAddMutationOptions(options), queryClient);
    }
    export type vendorApplicationDocumentsRemoveResponse204 = {
  data: void
  status: 204
}

export type vendorApplicationDocumentsRemoveResponseSuccess = (vendorApplicationDocumentsRemoveResponse204) & {
  headers: Headers;
};
;

export type vendorApplicationDocumentsRemoveResponse = (vendorApplicationDocumentsRemoveResponseSuccess)

export const getVendorApplicationDocumentsRemoveUrl = (uid: string,) => {




  return `/api/v1/vendor/application/documents/${uid}`
}

export const vendorApplicationDocumentsRemove = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationDocumentsRemoveResponse> => {

  return apiFetch<vendorApplicationDocumentsRemoveResponse>(getVendorApplicationDocumentsRemoveUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorApplicationDocumentsRemoveMutationKey = () => ['vendorApplicationDocumentsRemove'] as const;

export const getVendorApplicationDocumentsRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationDocumentsRemove>>, TError,VendorApplicationDocumentsRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationDocumentsRemove>>, TError,VendorApplicationDocumentsRemoveMutationVariables, TContext> => {

const mutationKey = getVendorApplicationDocumentsRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationDocumentsRemove>>, VendorApplicationDocumentsRemoveMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorApplicationDocumentsRemove(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationDocumentsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationDocumentsRemove>>>

    export type VendorApplicationDocumentsRemoveMutationError = unknown
    export type VendorApplicationDocumentsRemoveMutationVariables = {uid: string}

    export const useVendorApplicationDocumentsRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationDocumentsRemove>>, TError,VendorApplicationDocumentsRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationDocumentsRemove>>,
        TError,
        VendorApplicationDocumentsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationDocumentsRemoveMutationOptions(options), queryClient);
    }
    export type vendorApplicationPhoneSendResponse204 = {
  data: void
  status: 204
}

export type vendorApplicationPhoneSendResponseSuccess = (vendorApplicationPhoneSendResponse204) & {
  headers: Headers;
};
;

export type vendorApplicationPhoneSendResponse = (vendorApplicationPhoneSendResponseSuccess)

export const getVendorApplicationPhoneSendUrl = () => {




  return `/api/v1/vendor/application/phone/send`
}

export const vendorApplicationPhoneSend = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationPhoneSendResponse> => {

  return apiFetch<vendorApplicationPhoneSendResponse>(getVendorApplicationPhoneSendUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorApplicationPhoneSendMutationKey = () => ['vendorApplicationPhoneSend'] as const;

export const getVendorApplicationPhoneSendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPhoneSend>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPhoneSend>>, TError,void, TContext> => {

const mutationKey = getVendorApplicationPhoneSendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationPhoneSend>>, void> = () => {


          return  vendorApplicationPhoneSend(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationPhoneSendMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationPhoneSend>>>

    export type VendorApplicationPhoneSendMutationError = unknown


    export const useVendorApplicationPhoneSend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPhoneSend>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationPhoneSend>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getVendorApplicationPhoneSendMutationOptions(options), queryClient);
    }
    export type vendorApplicationPhoneVerifyResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationPhoneVerifyResponseSuccess = (vendorApplicationPhoneVerifyResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationPhoneVerifyResponse = (vendorApplicationPhoneVerifyResponseSuccess)

export const getVendorApplicationPhoneVerifyUrl = () => {




  return `/api/v1/vendor/application/phone/verify`
}

export const vendorApplicationPhoneVerify = async (phoneCodeRequest: PhoneCodeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationPhoneVerifyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationPhoneVerifyResponse>(getVendorApplicationPhoneVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(phoneCodeRequest)
  }
);}





export const getVendorApplicationPhoneVerifyMutationKey = () => ['vendorApplicationPhoneVerify'] as const;

export const getVendorApplicationPhoneVerifyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPhoneVerify>>, TError,VendorApplicationPhoneVerifyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPhoneVerify>>, TError,VendorApplicationPhoneVerifyMutationVariables, TContext> => {

const mutationKey = getVendorApplicationPhoneVerifyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationPhoneVerify>>, VendorApplicationPhoneVerifyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationPhoneVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationPhoneVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationPhoneVerify>>>
    export type VendorApplicationPhoneVerifyMutationBody = PhoneCodeRequest
    export type VendorApplicationPhoneVerifyMutationError = unknown
    export type VendorApplicationPhoneVerifyMutationVariables = {data: PhoneCodeRequest}

    export const useVendorApplicationPhoneVerify = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationPhoneVerify>>, TError,VendorApplicationPhoneVerifyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationPhoneVerify>>,
        TError,
        VendorApplicationPhoneVerifyMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationPhoneVerifyMutationOptions(options), queryClient);
    }
    export type vendorApplicationSubmitResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationSubmitResponseSuccess = (vendorApplicationSubmitResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationSubmitResponse = (vendorApplicationSubmitResponseSuccess)

export const getVendorApplicationSubmitUrl = () => {




  return `/api/v1/vendor/application/submit`
}

export const vendorApplicationSubmit = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationSubmitResponse> => {

  return apiFetch<vendorApplicationSubmitResponse>(getVendorApplicationSubmitUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorApplicationSubmitMutationKey = () => ['vendorApplicationSubmit'] as const;

export const getVendorApplicationSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationSubmit>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationSubmit>>, TError,void, TContext> => {

const mutationKey = getVendorApplicationSubmitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationSubmit>>, void> = () => {


          return  vendorApplicationSubmit(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationSubmit>>>

    export type VendorApplicationSubmitMutationError = unknown


    export const useVendorApplicationSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationSubmit>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationSubmit>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getVendorApplicationSubmitMutationOptions(options), queryClient);
    }
    export type vendorApplicationTaxIdsResponse200 = {
  data: VendorApplication
  status: 200
}

export type vendorApplicationTaxIdsResponseSuccess = (vendorApplicationTaxIdsResponse200) & {
  headers: Headers;
};
;

export type vendorApplicationTaxIdsResponse = (vendorApplicationTaxIdsResponseSuccess)

export const getVendorApplicationTaxIdsUrl = () => {




  return `/api/v1/vendor/application/tax-ids`
}

export const vendorApplicationTaxIds = async (taxIdsInputRequest?: TaxIdsInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorApplicationTaxIdsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorApplicationTaxIdsResponse>(getVendorApplicationTaxIdsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxIdsInputRequest)
  }
);}





export const getVendorApplicationTaxIdsMutationKey = () => ['vendorApplicationTaxIds'] as const;

export const getVendorApplicationTaxIdsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationTaxIds>>, TError,VendorApplicationTaxIdsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationTaxIds>>, TError,VendorApplicationTaxIdsMutationVariables, TContext> => {

const mutationKey = getVendorApplicationTaxIdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorApplicationTaxIds>>, VendorApplicationTaxIdsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorApplicationTaxIds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorApplicationTaxIdsMutationResult = NonNullable<Awaited<ReturnType<typeof vendorApplicationTaxIds>>>
    export type VendorApplicationTaxIdsMutationBody = TaxIdsInputRequest | undefined
    export type VendorApplicationTaxIdsMutationError = unknown
    export type VendorApplicationTaxIdsMutationVariables = {data?: TaxIdsInputRequest}

    export const useVendorApplicationTaxIds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorApplicationTaxIds>>, TError,VendorApplicationTaxIdsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorApplicationTaxIds>>,
        TError,
        VendorApplicationTaxIdsMutationVariables,
        TContext
      > => {
      return useMutation(getVendorApplicationTaxIdsMutationOptions(options), queryClient);
    }
    export type vendorBrandsListResponse200 = {
  data: StoreBrand[]
  status: 200
}

export type vendorBrandsListResponseSuccess = (vendorBrandsListResponse200) & {
  headers: Headers;
};
;

export type vendorBrandsListResponse = (vendorBrandsListResponseSuccess)

export const getVendorBrandsListUrl = (params?: VendorBrandsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/brands?${stringifiedParams}` : `/api/v1/vendor/brands`
}

/**
 * Active brands for the vendor product form: all of them (the editor's brand list), or the first 50 matches of
 * `?search=`.
 */
export const vendorBrandsList = async (params?: VendorBrandsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBrandsListResponse> => {

  return apiFetch<vendorBrandsListResponse>(getVendorBrandsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBrandsListQueryKey = (params?: VendorBrandsListParams,) => {
    return [
    `/api/v1/vendor/brands`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorBrandsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorBrandsList>>, TError = unknown>(params?: VendorBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBrandsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBrandsList>>> = ({ signal }) => vendorBrandsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBrandsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBrandsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBrandsList>>>
export type VendorBrandsListQueryError = unknown


export function useVendorBrandsList<TData = Awaited<ReturnType<typeof vendorBrandsList>>, TError = unknown>(
 params: undefined |  VendorBrandsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBrandsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBrandsList>>,
          TError,
          Awaited<ReturnType<typeof vendorBrandsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBrandsList<TData = Awaited<ReturnType<typeof vendorBrandsList>>, TError = unknown>(
 params?: VendorBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBrandsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBrandsList>>,
          TError,
          Awaited<ReturnType<typeof vendorBrandsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBrandsList<TData = Awaited<ReturnType<typeof vendorBrandsList>>, TError = unknown>(
 params?: VendorBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBrandsList<TData = Awaited<ReturnType<typeof vendorBrandsList>>, TError = unknown>(
 params?: VendorBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBrandsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadBatchesListResponse200 = {
  data: BulkBatchPage
  status: 200
}

export type vendorBulkUploadBatchesListResponseSuccess = (vendorBulkUploadBatchesListResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesListResponse = (vendorBulkUploadBatchesListResponseSuccess)

export const getVendorBulkUploadBatchesListUrl = (params?: VendorBulkUploadBatchesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/bulk-upload/batches?${stringifiedParams}` : `/api/v1/vendor/bulk-upload/batches`
}

export const vendorBulkUploadBatchesList = async (params?: VendorBulkUploadBatchesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesListResponse> => {

  return apiFetch<vendorBulkUploadBatchesListResponse>(getVendorBulkUploadBatchesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadBatchesListQueryKey = (params?: VendorBulkUploadBatchesListParams,) => {
    return [
    `/api/v1/vendor/bulk-upload/batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorBulkUploadBatchesListQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError = unknown>(params?: VendorBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadBatchesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>> = ({ signal }) => vendorBulkUploadBatchesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadBatchesListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>>
export type VendorBulkUploadBatchesListQueryError = unknown


export function useVendorBulkUploadBatchesList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError = unknown>(
 params: undefined |  VendorBulkUploadBatchesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError = unknown>(
 params?: VendorBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError = unknown>(
 params?: VendorBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadBatchesList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError = unknown>(
 params?: VendorBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadBatchesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadBatchesCreateResponse201 = {
  data: BulkBatchDetail
  status: 201
}

export type vendorBulkUploadBatchesCreateResponseSuccess = (vendorBulkUploadBatchesCreateResponse201) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesCreateResponse = (vendorBulkUploadBatchesCreateResponseSuccess)

export const getVendorBulkUploadBatchesCreateUrl = () => {




  return `/api/v1/vendor/bulk-upload/batches`
}

export const vendorBulkUploadBatchesCreate = async (bulkUploadRequest: BulkUploadRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, bulkUploadRequest.file);
if(bulkUploadRequest.auto_import !== undefined) {
 formData.append(`auto_import`, bulkUploadRequest.auto_import.toString())
 }
if(bulkUploadRequest.submit_for_approval !== undefined) {
 formData.append(`submit_for_approval`, bulkUploadRequest.submit_for_approval.toString())
 }
if(bulkUploadRequest.vendor !== undefined && bulkUploadRequest.vendor !== null) {
 formData.append(`vendor`, bulkUploadRequest.vendor);
 }

  return apiFetch<vendorBulkUploadBatchesCreateResponse>(getVendorBulkUploadBatchesCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getVendorBulkUploadBatchesCreateMutationKey = () => ['vendorBulkUploadBatchesCreate'] as const;

export const getVendorBulkUploadBatchesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesCreate>>, TError,VendorBulkUploadBatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesCreate>>, TError,VendorBulkUploadBatchesCreateMutationVariables, TContext> => {

const mutationKey = getVendorBulkUploadBatchesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesCreate>>, VendorBulkUploadBatchesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorBulkUploadBatchesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorBulkUploadBatchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesCreate>>>
    export type VendorBulkUploadBatchesCreateMutationBody = BulkUploadRequest
    export type VendorBulkUploadBatchesCreateMutationError = unknown
    export type VendorBulkUploadBatchesCreateMutationVariables = {data: BulkUploadRequest}

    export const useVendorBulkUploadBatchesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesCreate>>, TError,VendorBulkUploadBatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorBulkUploadBatchesCreate>>,
        TError,
        VendorBulkUploadBatchesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorBulkUploadBatchesCreateMutationOptions(options), queryClient);
    }
    export type vendorBulkUploadBatchesRetrieveResponse200 = {
  data: BulkBatchDetail
  status: 200
}

export type vendorBulkUploadBatchesRetrieveResponseSuccess = (vendorBulkUploadBatchesRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesRetrieveResponse = (vendorBulkUploadBatchesRetrieveResponseSuccess)

export const getVendorBulkUploadBatchesRetrieveUrl = (uid: string,) => {




  return `/api/v1/vendor/bulk-upload/batches/${uid}`
}

export const vendorBulkUploadBatchesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesRetrieveResponse> => {

  return apiFetch<vendorBulkUploadBatchesRetrieveResponse>(getVendorBulkUploadBatchesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadBatchesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/bulk-upload/batches/${uid}`
    ] as const;
    }


export const getVendorBulkUploadBatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadBatchesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>> = ({ signal }) => vendorBulkUploadBatchesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadBatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>>
export type VendorBulkUploadBatchesRetrieveQueryError = unknown


export function useVendorBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadBatchesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadBatchesDestroyResponse204 = {
  data: void
  status: 204
}

export type vendorBulkUploadBatchesDestroyResponseSuccess = (vendorBulkUploadBatchesDestroyResponse204) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesDestroyResponse = (vendorBulkUploadBatchesDestroyResponseSuccess)

export const getVendorBulkUploadBatchesDestroyUrl = (uid: string,) => {




  return `/api/v1/vendor/bulk-upload/batches/${uid}`
}

export const vendorBulkUploadBatchesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesDestroyResponse> => {

  return apiFetch<vendorBulkUploadBatchesDestroyResponse>(getVendorBulkUploadBatchesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorBulkUploadBatchesDestroyMutationKey = () => ['vendorBulkUploadBatchesDestroy'] as const;

export const getVendorBulkUploadBatchesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesDestroy>>, TError,VendorBulkUploadBatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesDestroy>>, TError,VendorBulkUploadBatchesDestroyMutationVariables, TContext> => {

const mutationKey = getVendorBulkUploadBatchesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesDestroy>>, VendorBulkUploadBatchesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorBulkUploadBatchesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorBulkUploadBatchesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesDestroy>>>

    export type VendorBulkUploadBatchesDestroyMutationError = unknown
    export type VendorBulkUploadBatchesDestroyMutationVariables = {uid: string}

    export const useVendorBulkUploadBatchesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesDestroy>>, TError,VendorBulkUploadBatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorBulkUploadBatchesDestroy>>,
        TError,
        VendorBulkUploadBatchesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getVendorBulkUploadBatchesDestroyMutationOptions(options), queryClient);
    }
    export type vendorBulkUploadBatchesErrorsRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type vendorBulkUploadBatchesErrorsRetrieveResponseSuccess = (vendorBulkUploadBatchesErrorsRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesErrorsRetrieveResponse = (vendorBulkUploadBatchesErrorsRetrieveResponseSuccess)

export const getVendorBulkUploadBatchesErrorsRetrieveUrl = (uid: string,) => {




  return `/api/v1/vendor/bulk-upload/batches/${uid}/errors`
}

export const vendorBulkUploadBatchesErrorsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesErrorsRetrieveResponse> => {

  return apiFetch<vendorBulkUploadBatchesErrorsRetrieveResponse>(getVendorBulkUploadBatchesErrorsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadBatchesErrorsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/bulk-upload/batches/${uid}/errors`
    ] as const;
    }


export const getVendorBulkUploadBatchesErrorsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadBatchesErrorsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>> = ({ signal }) => vendorBulkUploadBatchesErrorsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadBatchesErrorsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>>
export type VendorBulkUploadBatchesErrorsRetrieveQueryError = unknown


export function useVendorBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesErrorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadBatchesErrorsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadBatchesImportCreateResponse200 = {
  data: BulkBatchDetail
  status: 200
}

export type vendorBulkUploadBatchesImportCreateResponseSuccess = (vendorBulkUploadBatchesImportCreateResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesImportCreateResponse = (vendorBulkUploadBatchesImportCreateResponseSuccess)

export const getVendorBulkUploadBatchesImportCreateUrl = (uid: string,) => {




  return `/api/v1/vendor/bulk-upload/batches/${uid}/import`
}

export const vendorBulkUploadBatchesImportCreate = async (uid: string,
    bulkImportRequestRequest?: BulkImportRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesImportCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorBulkUploadBatchesImportCreateResponse>(getVendorBulkUploadBatchesImportCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkImportRequestRequest)
  }
);}





export const getVendorBulkUploadBatchesImportCreateMutationKey = () => ['vendorBulkUploadBatchesImportCreate'] as const;

export const getVendorBulkUploadBatchesImportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesImportCreate>>, TError,VendorBulkUploadBatchesImportCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesImportCreate>>, TError,VendorBulkUploadBatchesImportCreateMutationVariables, TContext> => {

const mutationKey = getVendorBulkUploadBatchesImportCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesImportCreate>>, VendorBulkUploadBatchesImportCreateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorBulkUploadBatchesImportCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorBulkUploadBatchesImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesImportCreate>>>
    export type VendorBulkUploadBatchesImportCreateMutationBody = BulkImportRequestRequest | undefined
    export type VendorBulkUploadBatchesImportCreateMutationError = unknown
    export type VendorBulkUploadBatchesImportCreateMutationVariables = {uid: string;data?: BulkImportRequestRequest}

    export const useVendorBulkUploadBatchesImportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesImportCreate>>, TError,VendorBulkUploadBatchesImportCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorBulkUploadBatchesImportCreate>>,
        TError,
        VendorBulkUploadBatchesImportCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorBulkUploadBatchesImportCreateMutationOptions(options), queryClient);
    }
    export type vendorBulkUploadBatchesRowsListResponse200 = {
  data: BulkRowPage
  status: 200
}

export type vendorBulkUploadBatchesRowsListResponseSuccess = (vendorBulkUploadBatchesRowsListResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadBatchesRowsListResponse = (vendorBulkUploadBatchesRowsListResponseSuccess)

export const getVendorBulkUploadBatchesRowsListUrl = (uid: string,
    params?: VendorBulkUploadBatchesRowsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/bulk-upload/batches/${uid}/rows?${stringifiedParams}` : `/api/v1/vendor/bulk-upload/batches/${uid}/rows`
}

export const vendorBulkUploadBatchesRowsList = async (uid: string,
    params?: VendorBulkUploadBatchesRowsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadBatchesRowsListResponse> => {

  return apiFetch<vendorBulkUploadBatchesRowsListResponse>(getVendorBulkUploadBatchesRowsListUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadBatchesRowsListQueryKey = (uid: string,
    params?: VendorBulkUploadBatchesRowsListParams,) => {
    return [
    `/api/v1/vendor/bulk-upload/batches/${uid}/rows`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorBulkUploadBatchesRowsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError = unknown>(uid: string,
    params?: VendorBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadBatchesRowsListQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>> = ({ signal }) => vendorBulkUploadBatchesRowsList(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadBatchesRowsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>>
export type VendorBulkUploadBatchesRowsListQueryError = unknown


export function useVendorBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params: undefined |  VendorBulkUploadBatchesRowsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params?: VendorBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params?: VendorBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params?: VendorBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadBatchesRowsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadBatchesRowsListQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadCategoriesListResponse200 = {
  data: BulkCategoryChoice[]
  status: 200
}

export type vendorBulkUploadCategoriesListResponseSuccess = (vendorBulkUploadCategoriesListResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadCategoriesListResponse = (vendorBulkUploadCategoriesListResponseSuccess)

export const getVendorBulkUploadCategoriesListUrl = () => {




  return `/api/v1/vendor/bulk-upload/categories`
}

export const vendorBulkUploadCategoriesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadCategoriesListResponse> => {

  return apiFetch<vendorBulkUploadCategoriesListResponse>(getVendorBulkUploadCategoriesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadCategoriesListQueryKey = () => {
    return [
    `/api/v1/vendor/bulk-upload/categories`
    ] as const;
    }


export const getVendorBulkUploadCategoriesListQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadCategoriesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>> = ({ signal }) => vendorBulkUploadCategoriesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>>
export type VendorBulkUploadCategoriesListQueryError = unknown


export function useVendorBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadCategoriesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadTemplateRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type vendorBulkUploadTemplateRetrieveResponseSuccess = (vendorBulkUploadTemplateRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadTemplateRetrieveResponse = (vendorBulkUploadTemplateRetrieveResponseSuccess)

export const getVendorBulkUploadTemplateRetrieveUrl = (params?: VendorBulkUploadTemplateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/bulk-upload/template?${stringifiedParams}` : `/api/v1/vendor/bulk-upload/template`
}

export const vendorBulkUploadTemplateRetrieve = async (params?: VendorBulkUploadTemplateRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadTemplateRetrieveResponse> => {

  return apiFetch<vendorBulkUploadTemplateRetrieveResponse>(getVendorBulkUploadTemplateRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadTemplateRetrieveQueryKey = (params?: VendorBulkUploadTemplateRetrieveParams,) => {
    return [
    `/api/v1/vendor/bulk-upload/template`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorBulkUploadTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError = unknown>(params?: VendorBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadTemplateRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>> = ({ signal }) => vendorBulkUploadTemplateRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>>
export type VendorBulkUploadTemplateRetrieveQueryError = unknown


export function useVendorBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError = unknown>(
 params: undefined |  VendorBulkUploadTemplateRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadTemplateRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadTemplateMacroRetrieveResponse200 = {
  data: string
  status: 200
}

export type vendorBulkUploadTemplateMacroRetrieveResponseSuccess = (vendorBulkUploadTemplateMacroRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadTemplateMacroRetrieveResponse = (vendorBulkUploadTemplateMacroRetrieveResponseSuccess)

export const getVendorBulkUploadTemplateMacroRetrieveUrl = (params?: VendorBulkUploadTemplateMacroRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/bulk-upload/template/macro?${stringifiedParams}` : `/api/v1/vendor/bulk-upload/template/macro`
}

export const vendorBulkUploadTemplateMacroRetrieve = async (params?: VendorBulkUploadTemplateMacroRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadTemplateMacroRetrieveResponse> => {

  return apiFetch<vendorBulkUploadTemplateMacroRetrieveResponse>(getVendorBulkUploadTemplateMacroRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadTemplateMacroRetrieveQueryKey = (params?: VendorBulkUploadTemplateMacroRetrieveParams,) => {
    return [
    `/api/v1/vendor/bulk-upload/template/macro`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorBulkUploadTemplateMacroRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError = unknown>(params?: VendorBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadTemplateMacroRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>> = ({ signal }) => vendorBulkUploadTemplateMacroRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadTemplateMacroRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>>
export type VendorBulkUploadTemplateMacroRetrieveQueryError = unknown


export function useVendorBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params: undefined |  VendorBulkUploadTemplateMacroRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadTemplateMacroRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadTemplateMacroRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorBulkUploadUpdateSheetRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type vendorBulkUploadUpdateSheetRetrieveResponseSuccess = (vendorBulkUploadUpdateSheetRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorBulkUploadUpdateSheetRetrieveResponse = (vendorBulkUploadUpdateSheetRetrieveResponseSuccess)

export const getVendorBulkUploadUpdateSheetRetrieveUrl = (params?: VendorBulkUploadUpdateSheetRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/bulk-upload/update-sheet?${stringifiedParams}` : `/api/v1/vendor/bulk-upload/update-sheet`
}

export const vendorBulkUploadUpdateSheetRetrieve = async (params?: VendorBulkUploadUpdateSheetRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorBulkUploadUpdateSheetRetrieveResponse> => {

  return apiFetch<vendorBulkUploadUpdateSheetRetrieveResponse>(getVendorBulkUploadUpdateSheetRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorBulkUploadUpdateSheetRetrieveQueryKey = (params?: VendorBulkUploadUpdateSheetRetrieveParams,) => {
    return [
    `/api/v1/vendor/bulk-upload/update-sheet`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorBulkUploadUpdateSheetRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError = unknown>(params?: VendorBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorBulkUploadUpdateSheetRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>> = ({ signal }) => vendorBulkUploadUpdateSheetRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorBulkUploadUpdateSheetRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>>
export type VendorBulkUploadUpdateSheetRetrieveQueryError = unknown


export function useVendorBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params: undefined |  VendorBulkUploadUpdateSheetRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params?: VendorBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorBulkUploadUpdateSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorBulkUploadUpdateSheetRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorCategoriesFormSchemaRetrieveResponse200 = {
  data: FormSchema
  status: 200
}

export type vendorCategoriesFormSchemaRetrieveResponseSuccess = (vendorCategoriesFormSchemaRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorCategoriesFormSchemaRetrieveResponse = (vendorCategoriesFormSchemaRetrieveResponseSuccess)

export const getVendorCategoriesFormSchemaRetrieveUrl = (uid: string,) => {




  return `/api/v1/vendor/categories/${uid}/form-schema`
}

/**
 * The product form of a category: its attribute set (own or inherited) and the fields by group.
 */
export const vendorCategoriesFormSchemaRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorCategoriesFormSchemaRetrieveResponse> => {

  return apiFetch<vendorCategoriesFormSchemaRetrieveResponse>(getVendorCategoriesFormSchemaRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorCategoriesFormSchemaRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/categories/${uid}/form-schema`
    ] as const;
    }


export const getVendorCategoriesFormSchemaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorCategoriesFormSchemaRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>> = ({ signal }) => vendorCategoriesFormSchemaRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorCategoriesFormSchemaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>>
export type VendorCategoriesFormSchemaRetrieveQueryError = unknown


export function useVendorCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorCategoriesFormSchemaRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorCategoriesFormSchemaValidateCreateResponse200 = {
  data: Validated
  status: 200
}

export type vendorCategoriesFormSchemaValidateCreateResponseSuccess = (vendorCategoriesFormSchemaValidateCreateResponse200) & {
  headers: Headers;
};
;

export type vendorCategoriesFormSchemaValidateCreateResponse = (vendorCategoriesFormSchemaValidateCreateResponseSuccess)

export const getVendorCategoriesFormSchemaValidateCreateUrl = (uid: string,) => {




  return `/api/v1/vendor/categories/${uid}/form-schema/validate`
}

/**
 * Checks specification values against the category's form; answers the cleaned values or field errors
 * (`attributes.<code>`).
 */
export const vendorCategoriesFormSchemaValidateCreate = async (uid: string,
    validateRequest: ValidateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorCategoriesFormSchemaValidateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorCategoriesFormSchemaValidateCreateResponse>(getVendorCategoriesFormSchemaValidateCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(validateRequest)
  }
);}





export const getVendorCategoriesFormSchemaValidateCreateMutationKey = () => ['vendorCategoriesFormSchemaValidateCreate'] as const;

export const getVendorCategoriesFormSchemaValidateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaValidateCreate>>, TError,VendorCategoriesFormSchemaValidateCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaValidateCreate>>, TError,VendorCategoriesFormSchemaValidateCreateMutationVariables, TContext> => {

const mutationKey = getVendorCategoriesFormSchemaValidateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorCategoriesFormSchemaValidateCreate>>, VendorCategoriesFormSchemaValidateCreateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorCategoriesFormSchemaValidateCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorCategoriesFormSchemaValidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorCategoriesFormSchemaValidateCreate>>>
    export type VendorCategoriesFormSchemaValidateCreateMutationBody = ValidateRequest
    export type VendorCategoriesFormSchemaValidateCreateMutationError = unknown
    export type VendorCategoriesFormSchemaValidateCreateMutationVariables = {uid: string;data: ValidateRequest}

    export const useVendorCategoriesFormSchemaValidateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorCategoriesFormSchemaValidateCreate>>, TError,VendorCategoriesFormSchemaValidateCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorCategoriesFormSchemaValidateCreate>>,
        TError,
        VendorCategoriesFormSchemaValidateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorCategoriesFormSchemaValidateCreateMutationOptions(options), queryClient);
    }
    export type vendorCouriersListResponse200 = {
  data: VendorCourier[]
  status: 200
}

export type vendorCouriersListResponseSuccess = (vendorCouriersListResponse200) & {
  headers: Headers;
};
;

export type vendorCouriersListResponse = (vendorCouriersListResponseSuccess)

export const getVendorCouriersListUrl = () => {




  return `/api/v1/vendor/couriers`
}

/**
 * Active couriers (vendors pick one when they ship an order).
 */
export const vendorCouriersList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorCouriersListResponse> => {

  return apiFetch<vendorCouriersListResponse>(getVendorCouriersListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorCouriersListQueryKey = () => {
    return [
    `/api/v1/vendor/couriers`
    ] as const;
    }


export const getVendorCouriersListQueryOptions = <TData = Awaited<ReturnType<typeof vendorCouriersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCouriersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorCouriersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorCouriersList>>> = ({ signal }) => vendorCouriersList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorCouriersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorCouriersListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorCouriersList>>>
export type VendorCouriersListQueryError = unknown


export function useVendorCouriersList<TData = Awaited<ReturnType<typeof vendorCouriersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCouriersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorCouriersList>>,
          TError,
          Awaited<ReturnType<typeof vendorCouriersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorCouriersList<TData = Awaited<ReturnType<typeof vendorCouriersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCouriersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorCouriersList>>,
          TError,
          Awaited<ReturnType<typeof vendorCouriersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorCouriersList<TData = Awaited<ReturnType<typeof vendorCouriersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCouriersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorCouriersList<TData = Awaited<ReturnType<typeof vendorCouriersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorCouriersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorCouriersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorEarningsLedgerResponse200 = {
  data: PaginatedEntryList
  status: 200
}

export type vendorEarningsLedgerResponseSuccess = (vendorEarningsLedgerResponse200) & {
  headers: Headers;
};
;

export type vendorEarningsLedgerResponse = (vendorEarningsLedgerResponseSuccess)

export const getVendorEarningsLedgerUrl = (params?: VendorEarningsLedgerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/earnings/ledger?${stringifiedParams}` : `/api/v1/vendor/earnings/ledger`
}

export const vendorEarningsLedger = async (params?: VendorEarningsLedgerParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorEarningsLedgerResponse> => {

  return apiFetch<vendorEarningsLedgerResponse>(getVendorEarningsLedgerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorEarningsLedgerQueryKey = (params?: VendorEarningsLedgerParams,) => {
    return [
    `/api/v1/vendor/earnings/ledger`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorEarningsLedgerQueryOptions = <TData = Awaited<ReturnType<typeof vendorEarningsLedger>>, TError = unknown>(params?: VendorEarningsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorEarningsLedgerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorEarningsLedger>>> = ({ signal }) => vendorEarningsLedger(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsLedger>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorEarningsLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof vendorEarningsLedger>>>
export type VendorEarningsLedgerQueryError = unknown


export function useVendorEarningsLedger<TData = Awaited<ReturnType<typeof vendorEarningsLedger>>, TError = unknown>(
 params: undefined |  VendorEarningsLedgerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsLedger>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsLedger>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsLedger<TData = Awaited<ReturnType<typeof vendorEarningsLedger>>, TError = unknown>(
 params?: VendorEarningsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsLedger>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsLedger>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsLedger<TData = Awaited<ReturnType<typeof vendorEarningsLedger>>, TError = unknown>(
 params?: VendorEarningsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorEarningsLedger<TData = Awaited<ReturnType<typeof vendorEarningsLedger>>, TError = unknown>(
 params?: VendorEarningsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorEarningsLedgerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorEarningsPayoutsResponse200 = {
  data: PaginatedPayoutList
  status: 200
}

export type vendorEarningsPayoutsResponseSuccess = (vendorEarningsPayoutsResponse200) & {
  headers: Headers;
};
;

export type vendorEarningsPayoutsResponse = (vendorEarningsPayoutsResponseSuccess)

export const getVendorEarningsPayoutsUrl = (params?: VendorEarningsPayoutsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/earnings/payouts?${stringifiedParams}` : `/api/v1/vendor/earnings/payouts`
}

export const vendorEarningsPayouts = async (params?: VendorEarningsPayoutsParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorEarningsPayoutsResponse> => {

  return apiFetch<vendorEarningsPayoutsResponse>(getVendorEarningsPayoutsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorEarningsPayoutsQueryKey = (params?: VendorEarningsPayoutsParams,) => {
    return [
    `/api/v1/vendor/earnings/payouts`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorEarningsPayoutsQueryOptions = <TData = Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError = unknown>(params?: VendorEarningsPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorEarningsPayoutsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorEarningsPayouts>>> = ({ signal }) => vendorEarningsPayouts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorEarningsPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorEarningsPayouts>>>
export type VendorEarningsPayoutsQueryError = unknown


export function useVendorEarningsPayouts<TData = Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError = unknown>(
 params: undefined |  VendorEarningsPayoutsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsPayouts>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsPayouts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsPayouts<TData = Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError = unknown>(
 params?: VendorEarningsPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsPayouts>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsPayouts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsPayouts<TData = Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError = unknown>(
 params?: VendorEarningsPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorEarningsPayouts<TData = Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError = unknown>(
 params?: VendorEarningsPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayouts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorEarningsPayoutsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorEarningsPayoutResponse200 = {
  data: PayoutDetail
  status: 200
}

export type vendorEarningsPayoutResponseSuccess = (vendorEarningsPayoutResponse200) & {
  headers: Headers;
};
;

export type vendorEarningsPayoutResponse = (vendorEarningsPayoutResponseSuccess)

export const getVendorEarningsPayoutUrl = (uid: string,) => {




  return `/api/v1/vendor/earnings/payouts/${uid}`
}

export const vendorEarningsPayout = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorEarningsPayoutResponse> => {

  return apiFetch<vendorEarningsPayoutResponse>(getVendorEarningsPayoutUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorEarningsPayoutQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/earnings/payouts/${uid}`
    ] as const;
    }


export const getVendorEarningsPayoutQueryOptions = <TData = Awaited<ReturnType<typeof vendorEarningsPayout>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayout>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorEarningsPayoutQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorEarningsPayout>>> = ({ signal }) => vendorEarningsPayout(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorEarningsPayoutQueryResult = NonNullable<Awaited<ReturnType<typeof vendorEarningsPayout>>>
export type VendorEarningsPayoutQueryError = unknown


export function useVendorEarningsPayout<TData = Awaited<ReturnType<typeof vendorEarningsPayout>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsPayout>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsPayout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsPayout<TData = Awaited<ReturnType<typeof vendorEarningsPayout>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsPayout>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsPayout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsPayout<TData = Awaited<ReturnType<typeof vendorEarningsPayout>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayout>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorEarningsPayout<TData = Awaited<ReturnType<typeof vendorEarningsPayout>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsPayout>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorEarningsPayoutQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorEarningsSummaryResponse200 = {
  data: Summary
  status: 200
}

export type vendorEarningsSummaryResponseSuccess = (vendorEarningsSummaryResponse200) & {
  headers: Headers;
};
;

export type vendorEarningsSummaryResponse = (vendorEarningsSummaryResponseSuccess)

export const getVendorEarningsSummaryUrl = () => {




  return `/api/v1/vendor/earnings/summary`
}

export const vendorEarningsSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorEarningsSummaryResponse> => {

  return apiFetch<vendorEarningsSummaryResponse>(getVendorEarningsSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorEarningsSummaryQueryKey = () => {
    return [
    `/api/v1/vendor/earnings/summary`
    ] as const;
    }


export const getVendorEarningsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof vendorEarningsSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorEarningsSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorEarningsSummary>>> = ({ signal }) => vendorEarningsSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorEarningsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof vendorEarningsSummary>>>
export type VendorEarningsSummaryQueryError = unknown


export function useVendorEarningsSummary<TData = Awaited<ReturnType<typeof vendorEarningsSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsSummary>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsSummary<TData = Awaited<ReturnType<typeof vendorEarningsSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsSummary>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsSummary<TData = Awaited<ReturnType<typeof vendorEarningsSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorEarningsSummary<TData = Awaited<ReturnType<typeof vendorEarningsSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorEarningsSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorEarningsTaxDeductionsResponse200 = {
  data: TaxDeductionSummary
  status: 200
}

export type vendorEarningsTaxDeductionsResponseSuccess = (vendorEarningsTaxDeductionsResponse200) & {
  headers: Headers;
};
;

export type vendorEarningsTaxDeductionsResponse = (vendorEarningsTaxDeductionsResponseSuccess)

export const getVendorEarningsTaxDeductionsUrl = (params?: VendorEarningsTaxDeductionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/earnings/tax-deductions?${stringifiedParams}` : `/api/v1/vendor/earnings/tax-deductions`
}

export const vendorEarningsTaxDeductions = async (params?: VendorEarningsTaxDeductionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorEarningsTaxDeductionsResponse> => {

  return apiFetch<vendorEarningsTaxDeductionsResponse>(getVendorEarningsTaxDeductionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorEarningsTaxDeductionsQueryKey = (params?: VendorEarningsTaxDeductionsParams,) => {
    return [
    `/api/v1/vendor/earnings/tax-deductions`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorEarningsTaxDeductionsQueryOptions = <TData = Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError = unknown>(params?: VendorEarningsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorEarningsTaxDeductionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>> = ({ signal }) => vendorEarningsTaxDeductions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorEarningsTaxDeductionsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>>
export type VendorEarningsTaxDeductionsQueryError = unknown


export function useVendorEarningsTaxDeductions<TData = Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError = unknown>(
 params: undefined |  VendorEarningsTaxDeductionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsTaxDeductions<TData = Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError = unknown>(
 params?: VendorEarningsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>,
          TError,
          Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorEarningsTaxDeductions<TData = Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError = unknown>(
 params?: VendorEarningsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorEarningsTaxDeductions<TData = Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError = unknown>(
 params?: VendorEarningsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorEarningsTaxDeductions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorEarningsTaxDeductionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorFeaturesRetrieveResponse200 = {
  data: VendorFeaturesRetrieve200
  status: 200
}

export type vendorFeaturesRetrieveResponseSuccess = (vendorFeaturesRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorFeaturesRetrieveResponse = (vendorFeaturesRetrieveResponseSuccess)

export const getVendorFeaturesRetrieveUrl = () => {




  return `/api/v1/vendor/features`
}

/**
 * Flags exposed to vendors, resolved for the user's vendor (per-vendor overrides applied).
 */
export const vendorFeaturesRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorFeaturesRetrieveResponse> => {

  return apiFetch<vendorFeaturesRetrieveResponse>(getVendorFeaturesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorFeaturesRetrieveQueryKey = () => {
    return [
    `/api/v1/vendor/features`
    ] as const;
    }


export const getVendorFeaturesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorFeaturesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>> = ({ signal }) => vendorFeaturesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorFeaturesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>>
export type VendorFeaturesRetrieveQueryError = unknown


export function useVendorFeaturesRetrieve<TData = Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorFeaturesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorFeaturesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorFeaturesRetrieve<TData = Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorFeaturesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorFeaturesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorFeaturesRetrieve<TData = Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorFeaturesRetrieve<TData = Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorFeaturesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorInvoicesListResponse200 = {
  data: PaginatedInvoiceList
  status: 200
}

export type vendorInvoicesListResponseSuccess = (vendorInvoicesListResponse200) & {
  headers: Headers;
};
;

export type vendorInvoicesListResponse = (vendorInvoicesListResponseSuccess)

export const getVendorInvoicesListUrl = (params?: VendorInvoicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/invoices?${stringifiedParams}` : `/api/v1/vendor/invoices`
}

export const vendorInvoicesList = async (params?: VendorInvoicesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorInvoicesListResponse> => {

  return apiFetch<vendorInvoicesListResponse>(getVendorInvoicesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorInvoicesListQueryKey = (params?: VendorInvoicesListParams,) => {
    return [
    `/api/v1/vendor/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorInvoicesListQueryOptions = <TData = Awaited<ReturnType<typeof vendorInvoicesList>>, TError = unknown>(params?: VendorInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorInvoicesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorInvoicesList>>> = ({ signal }) => vendorInvoicesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorInvoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorInvoicesList>>>
export type VendorInvoicesListQueryError = unknown


export function useVendorInvoicesList<TData = Awaited<ReturnType<typeof vendorInvoicesList>>, TError = unknown>(
 params: undefined |  VendorInvoicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof vendorInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorInvoicesList<TData = Awaited<ReturnType<typeof vendorInvoicesList>>, TError = unknown>(
 params?: VendorInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof vendorInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorInvoicesList<TData = Awaited<ReturnType<typeof vendorInvoicesList>>, TError = unknown>(
 params?: VendorInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorInvoicesList<TData = Awaited<ReturnType<typeof vendorInvoicesList>>, TError = unknown>(
 params?: VendorInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorInvoicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorInvoicesPdfResponse200 = {
  data: Blob
  status: 200
}

export type vendorInvoicesPdfResponseSuccess = (vendorInvoicesPdfResponse200) & {
  headers: Headers;
};
;

export type vendorInvoicesPdfResponse = (vendorInvoicesPdfResponseSuccess)

export const getVendorInvoicesPdfUrl = (uid: string,) => {




  return `/api/v1/vendor/invoices/${uid}/pdf`
}

export const vendorInvoicesPdf = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorInvoicesPdfResponse> => {

  return apiFetch<vendorInvoicesPdfResponse>(getVendorInvoicesPdfUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorInvoicesPdfQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/invoices/${uid}/pdf`
    ] as const;
    }


export const getVendorInvoicesPdfQueryOptions = <TData = Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorInvoicesPdfQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorInvoicesPdf>>> = ({ signal }) => vendorInvoicesPdf(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorInvoicesPdfQueryResult = NonNullable<Awaited<ReturnType<typeof vendorInvoicesPdf>>>
export type VendorInvoicesPdfQueryError = unknown


export function useVendorInvoicesPdf<TData = Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorInvoicesPdf>>,
          TError,
          Awaited<ReturnType<typeof vendorInvoicesPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorInvoicesPdf<TData = Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorInvoicesPdf>>,
          TError,
          Awaited<ReturnType<typeof vendorInvoicesPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorInvoicesPdf<TData = Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorInvoicesPdf<TData = Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorInvoicesPdfQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorMeRetrieveResponse200 = {
  data: VendorMe
  status: 200
}

export type vendorMeRetrieveResponseSuccess = (vendorMeRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorMeRetrieveResponse = (vendorMeRetrieveResponseSuccess)

export const getVendorMeRetrieveUrl = () => {




  return `/api/v1/vendor/me`
}

/**
 * The user plus their vendor (filled in by the vendors module through `vendor_context`).
 */
export const vendorMeRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorMeRetrieveResponse> => {

  return apiFetch<vendorMeRetrieveResponse>(getVendorMeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorMeRetrieveQueryKey = () => {
    return [
    `/api/v1/vendor/me`
    ] as const;
    }


export const getVendorMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorMeRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorMeRetrieve>>> = ({ signal }) => vendorMeRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorMeRetrieve>>>
export type VendorMeRetrieveQueryError = unknown


export function useVendorMeRetrieve<TData = Awaited<ReturnType<typeof vendorMeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMeRetrieve<TData = Awaited<ReturnType<typeof vendorMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMeRetrieve<TData = Awaited<ReturnType<typeof vendorMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorMeRetrieve<TData = Awaited<ReturnType<typeof vendorMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorMePartialUpdateResponse200 = {
  data: VendorMe
  status: 200
}

export type vendorMePartialUpdateResponseSuccess = (vendorMePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorMePartialUpdateResponse = (vendorMePartialUpdateResponseSuccess)

export const getVendorMePartialUpdateUrl = () => {




  return `/api/v1/vendor/me`
}

/**
 * The user plus their vendor (filled in by the vendors module through `vendor_context`).
 */
export const vendorMePartialUpdate = async (patchedProfileUpdateRequest?: PatchedProfileUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMePartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorMePartialUpdateResponse>(getVendorMePartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProfileUpdateRequest)
  }
);}





export const getVendorMePartialUpdateMutationKey = () => ['vendorMePartialUpdate'] as const;

export const getVendorMePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMePartialUpdate>>, TError,VendorMePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMePartialUpdate>>, TError,VendorMePartialUpdateMutationVariables, TContext> => {

const mutationKey = getVendorMePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMePartialUpdate>>, VendorMePartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorMePartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMePartialUpdate>>>
    export type VendorMePartialUpdateMutationBody = PatchedProfileUpdateRequest | undefined
    export type VendorMePartialUpdateMutationError = unknown
    export type VendorMePartialUpdateMutationVariables = {data?: PatchedProfileUpdateRequest}

    export const useVendorMePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMePartialUpdate>>, TError,VendorMePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMePartialUpdate>>,
        TError,
        VendorMePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMePartialUpdateMutationOptions(options), queryClient);
    }
    export type vendorMediaListResponse200 = {
  data: PaginatedMediaList
  status: 200
}

export type vendorMediaListResponseSuccess = (vendorMediaListResponse200) & {
  headers: Headers;
};
;

export type vendorMediaListResponse = (vendorMediaListResponseSuccess)

export const getVendorMediaListUrl = (params?: VendorMediaListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/media?${stringifiedParams}` : `/api/v1/vendor/media`
}

/**
 * List media (page pagination, filters) or upload a file (multipart, field `file`).
 */
export const vendorMediaList = async (params?: VendorMediaListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaListResponse> => {

  return apiFetch<vendorMediaListResponse>(getVendorMediaListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorMediaListQueryKey = (params?: VendorMediaListParams,) => {
    return [
    `/api/v1/vendor/media`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorMediaListQueryOptions = <TData = Awaited<ReturnType<typeof vendorMediaList>>, TError = unknown>(params?: VendorMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorMediaListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorMediaList>>> = ({ signal }) => vendorMediaList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorMediaList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorMediaListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorMediaList>>>
export type VendorMediaListQueryError = unknown


export function useVendorMediaList<TData = Awaited<ReturnType<typeof vendorMediaList>>, TError = unknown>(
 params: undefined |  VendorMediaListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaList>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaList<TData = Awaited<ReturnType<typeof vendorMediaList>>, TError = unknown>(
 params?: VendorMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaList>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaList<TData = Awaited<ReturnType<typeof vendorMediaList>>, TError = unknown>(
 params?: VendorMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorMediaList<TData = Awaited<ReturnType<typeof vendorMediaList>>, TError = unknown>(
 params?: VendorMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorMediaListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorMediaCreateResponse200 = {
  data: MediaDetail
  status: 200
}

export type vendorMediaCreateResponse201 = {
  data: MediaDetail
  status: 201
}

export type vendorMediaCreateResponseSuccess = (vendorMediaCreateResponse200 | vendorMediaCreateResponse201) & {
  headers: Headers;
};
;

export type vendorMediaCreateResponse = (vendorMediaCreateResponseSuccess)

export const getVendorMediaCreateUrl = () => {




  return `/api/v1/vendor/media`
}

/**
 * 201 = stored; 200 = the same file was already in the library (that one is returned).
 */
export const vendorMediaCreate = async (uploadRequest: UploadRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadRequest.file);
if(uploadRequest.visibility !== undefined) {
 formData.append(`visibility`, uploadRequest.visibility);
 }
if(uploadRequest.folder !== undefined && uploadRequest.folder !== null) {
 formData.append(`folder`, uploadRequest.folder);
 }
if(uploadRequest.title !== undefined) {
 formData.append(`title`, uploadRequest.title);
 }
if(uploadRequest.alt_text !== undefined) {
 formData.append(`alt_text`, uploadRequest.alt_text);
 }

  return apiFetch<vendorMediaCreateResponse>(getVendorMediaCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getVendorMediaCreateMutationKey = () => ['vendorMediaCreate'] as const;

export const getVendorMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaCreate>>, TError,VendorMediaCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaCreate>>, TError,VendorMediaCreateMutationVariables, TContext> => {

const mutationKey = getVendorMediaCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaCreate>>, VendorMediaCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorMediaCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaCreate>>>
    export type VendorMediaCreateMutationBody = UploadRequest
    export type VendorMediaCreateMutationError = unknown
    export type VendorMediaCreateMutationVariables = {data: UploadRequest}

    export const useVendorMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaCreate>>, TError,VendorMediaCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaCreate>>,
        TError,
        VendorMediaCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaCreateMutationOptions(options), queryClient);
    }
    export type vendorMediaRetrieveResponse200 = {
  data: MediaDetail
  status: 200
}

export type vendorMediaRetrieveResponseSuccess = (vendorMediaRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorMediaRetrieveResponse = (vendorMediaRetrieveResponseSuccess)

export const getVendorMediaRetrieveUrl = (uid: string,
    params?: VendorMediaRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/media/${uid}?${stringifiedParams}` : `/api/v1/vendor/media/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaRetrieve = async (uid: string,
    params?: VendorMediaRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaRetrieveResponse> => {

  return apiFetch<vendorMediaRetrieveResponse>(getVendorMediaRetrieveUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorMediaRetrieveQueryKey = (uid: string,
    params?: VendorMediaRetrieveParams,) => {
    return [
    `/api/v1/vendor/media/${uid}`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorMediaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError = unknown>(uid: string,
    params?: VendorMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorMediaRetrieveQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorMediaRetrieve>>> = ({ signal }) => vendorMediaRetrieve(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorMediaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorMediaRetrieve>>>
export type VendorMediaRetrieveQueryError = unknown


export function useVendorMediaRetrieve<TData = Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError = unknown>(
 uid: string,
    params: undefined |  VendorMediaRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaRetrieve<TData = Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError = unknown>(
 uid: string,
    params?: VendorMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaRetrieve<TData = Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError = unknown>(
 uid: string,
    params?: VendorMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorMediaRetrieve<TData = Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError = unknown>(
 uid: string,
    params?: VendorMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorMediaRetrieveQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorMediaPartialUpdateResponse200 = {
  data: MediaDetail
  status: 200
}

export type vendorMediaPartialUpdateResponseSuccess = (vendorMediaPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorMediaPartialUpdateResponse = (vendorMediaPartialUpdateResponseSuccess)

export const getVendorMediaPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/vendor/media/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaPartialUpdate = async (uid: string,
    patchedMediaUpdateRequest?: PatchedMediaUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorMediaPartialUpdateResponse>(getVendorMediaPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedMediaUpdateRequest)
  }
);}





export const getVendorMediaPartialUpdateMutationKey = () => ['vendorMediaPartialUpdate'] as const;

export const getVendorMediaPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaPartialUpdate>>, TError,VendorMediaPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaPartialUpdate>>, TError,VendorMediaPartialUpdateMutationVariables, TContext> => {

const mutationKey = getVendorMediaPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaPartialUpdate>>, VendorMediaPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorMediaPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaPartialUpdate>>>
    export type VendorMediaPartialUpdateMutationBody = PatchedMediaUpdateRequest | undefined
    export type VendorMediaPartialUpdateMutationError = unknown
    export type VendorMediaPartialUpdateMutationVariables = {uid: string;data?: PatchedMediaUpdateRequest}

    export const useVendorMediaPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaPartialUpdate>>, TError,VendorMediaPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaPartialUpdate>>,
        TError,
        VendorMediaPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaPartialUpdateMutationOptions(options), queryClient);
    }
    export type vendorMediaDestroyResponse204 = {
  data: void
  status: 204
}

export type vendorMediaDestroyResponseSuccess = (vendorMediaDestroyResponse204) & {
  headers: Headers;
};
;

export type vendorMediaDestroyResponse = (vendorMediaDestroyResponseSuccess)

export const getVendorMediaDestroyUrl = (uid: string,
    params?: VendorMediaDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/media/${uid}?${stringifiedParams}` : `/api/v1/vendor/media/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaDestroy = async (uid: string,
    params?: VendorMediaDestroyParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaDestroyResponse> => {

  return apiFetch<vendorMediaDestroyResponse>(getVendorMediaDestroyUrl(uid,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorMediaDestroyMutationKey = () => ['vendorMediaDestroy'] as const;

export const getVendorMediaDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaDestroy>>, TError,VendorMediaDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaDestroy>>, TError,VendorMediaDestroyMutationVariables, TContext> => {

const mutationKey = getVendorMediaDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaDestroy>>, VendorMediaDestroyMutationVariables> = (props) => {
          const {uid,params} = props ?? {};

          return  vendorMediaDestroy(uid,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaDestroy>>>

    export type VendorMediaDestroyMutationError = unknown
    export type VendorMediaDestroyMutationVariables = {uid: string;params?: VendorMediaDestroyParams}

    export const useVendorMediaDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaDestroy>>, TError,VendorMediaDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaDestroy>>,
        TError,
        VendorMediaDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaDestroyMutationOptions(options), queryClient);
    }
    export type vendorMediaFileRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type vendorMediaFileRetrieveResponse302 = {
  data: void
  status: 302
}

export type vendorMediaFileRetrieveResponseSuccess = (vendorMediaFileRetrieveResponse200) & {
  headers: Headers;
};
export type vendorMediaFileRetrieveResponseError = (vendorMediaFileRetrieveResponse302) & {
  headers: Headers;
};

export type vendorMediaFileRetrieveResponse = (vendorMediaFileRetrieveResponseSuccess | vendorMediaFileRetrieveResponseError)

export const getVendorMediaFileRetrieveUrl = (uid: string,
    params?: VendorMediaFileRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/media/${uid}/file?${stringifiedParams}` : `/api/v1/vendor/media/${uid}/file`
}

/**
 * The original file (private files only through here). `?download=true` = save instead of open.
 */
export const vendorMediaFileRetrieve = async (uid: string,
    params?: VendorMediaFileRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaFileRetrieveResponse> => {

  return apiFetch<vendorMediaFileRetrieveResponse>(getVendorMediaFileRetrieveUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorMediaFileRetrieveQueryKey = (uid: string,
    params?: VendorMediaFileRetrieveParams,) => {
    return [
    `/api/v1/vendor/media/${uid}/file`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorMediaFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError = void>(uid: string,
    params?: VendorMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorMediaFileRetrieveQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>> = ({ signal }) => vendorMediaFileRetrieve(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorMediaFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>>
export type VendorMediaFileRetrieveQueryError = void


export function useVendorMediaFileRetrieve<TData = Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError = void>(
 uid: string,
    params: undefined |  VendorMediaFileRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaFileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaFileRetrieve<TData = Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError = void>(
 uid: string,
    params?: VendorMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaFileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaFileRetrieve<TData = Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError = void>(
 uid: string,
    params?: VendorMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorMediaFileRetrieve<TData = Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError = void>(
 uid: string,
    params?: VendorMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorMediaFileRetrieveQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorMediaRestoreCreateResponse200 = {
  data: MediaDetail
  status: 200
}

export type vendorMediaRestoreCreateResponseSuccess = (vendorMediaRestoreCreateResponse200) & {
  headers: Headers;
};
;

export type vendorMediaRestoreCreateResponse = (vendorMediaRestoreCreateResponseSuccess)

export const getVendorMediaRestoreCreateUrl = (uid: string,) => {




  return `/api/v1/vendor/media/${uid}/restore`
}

/**
 * Take a file out of the trash.
 */
export const vendorMediaRestoreCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaRestoreCreateResponse> => {

  return apiFetch<vendorMediaRestoreCreateResponse>(getVendorMediaRestoreCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorMediaRestoreCreateMutationKey = () => ['vendorMediaRestoreCreate'] as const;

export const getVendorMediaRestoreCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaRestoreCreate>>, TError,VendorMediaRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaRestoreCreate>>, TError,VendorMediaRestoreCreateMutationVariables, TContext> => {

const mutationKey = getVendorMediaRestoreCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaRestoreCreate>>, VendorMediaRestoreCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorMediaRestoreCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaRestoreCreate>>>

    export type VendorMediaRestoreCreateMutationError = unknown
    export type VendorMediaRestoreCreateMutationVariables = {uid: string}

    export const useVendorMediaRestoreCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaRestoreCreate>>, TError,VendorMediaRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaRestoreCreate>>,
        TError,
        VendorMediaRestoreCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaRestoreCreateMutationOptions(options), queryClient);
    }
    export type vendorMediaFoldersListResponse200 = {
  data: Folder[]
  status: 200
}

export type vendorMediaFoldersListResponseSuccess = (vendorMediaFoldersListResponse200) & {
  headers: Headers;
};
;

export type vendorMediaFoldersListResponse = (vendorMediaFoldersListResponseSuccess)

export const getVendorMediaFoldersListUrl = () => {




  return `/api/v1/vendor/media/folders`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaFoldersList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaFoldersListResponse> => {

  return apiFetch<vendorMediaFoldersListResponse>(getVendorMediaFoldersListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorMediaFoldersListQueryKey = () => {
    return [
    `/api/v1/vendor/media/folders`
    ] as const;
    }


export const getVendorMediaFoldersListQueryOptions = <TData = Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorMediaFoldersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorMediaFoldersList>>> = ({ signal }) => vendorMediaFoldersList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorMediaFoldersListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorMediaFoldersList>>>
export type VendorMediaFoldersListQueryError = unknown


export function useVendorMediaFoldersList<TData = Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaFoldersList>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaFoldersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaFoldersList<TData = Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorMediaFoldersList>>,
          TError,
          Awaited<ReturnType<typeof vendorMediaFoldersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorMediaFoldersList<TData = Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorMediaFoldersList<TData = Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorMediaFoldersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorMediaFoldersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorMediaFoldersCreateResponse201 = {
  data: Folder
  status: 201
}

export type vendorMediaFoldersCreateResponseSuccess = (vendorMediaFoldersCreateResponse201) & {
  headers: Headers;
};
;

export type vendorMediaFoldersCreateResponse = (vendorMediaFoldersCreateResponseSuccess)

export const getVendorMediaFoldersCreateUrl = () => {




  return `/api/v1/vendor/media/folders`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaFoldersCreate = async (folderWriteRequest: FolderWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaFoldersCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorMediaFoldersCreateResponse>(getVendorMediaFoldersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(folderWriteRequest)
  }
);}





export const getVendorMediaFoldersCreateMutationKey = () => ['vendorMediaFoldersCreate'] as const;

export const getVendorMediaFoldersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersCreate>>, TError,VendorMediaFoldersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersCreate>>, TError,VendorMediaFoldersCreateMutationVariables, TContext> => {

const mutationKey = getVendorMediaFoldersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaFoldersCreate>>, VendorMediaFoldersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorMediaFoldersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaFoldersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaFoldersCreate>>>
    export type VendorMediaFoldersCreateMutationBody = FolderWriteRequest
    export type VendorMediaFoldersCreateMutationError = unknown
    export type VendorMediaFoldersCreateMutationVariables = {data: FolderWriteRequest}

    export const useVendorMediaFoldersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersCreate>>, TError,VendorMediaFoldersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaFoldersCreate>>,
        TError,
        VendorMediaFoldersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaFoldersCreateMutationOptions(options), queryClient);
    }
    export type vendorMediaFoldersPartialUpdateResponse200 = {
  data: Folder
  status: 200
}

export type vendorMediaFoldersPartialUpdateResponseSuccess = (vendorMediaFoldersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorMediaFoldersPartialUpdateResponse = (vendorMediaFoldersPartialUpdateResponseSuccess)

export const getVendorMediaFoldersPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/vendor/media/folders/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaFoldersPartialUpdate = async (uid: string,
    patchedFolderWriteRequest?: PatchedFolderWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaFoldersPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorMediaFoldersPartialUpdateResponse>(getVendorMediaFoldersPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFolderWriteRequest)
  }
);}





export const getVendorMediaFoldersPartialUpdateMutationKey = () => ['vendorMediaFoldersPartialUpdate'] as const;

export const getVendorMediaFoldersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersPartialUpdate>>, TError,VendorMediaFoldersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersPartialUpdate>>, TError,VendorMediaFoldersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getVendorMediaFoldersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaFoldersPartialUpdate>>, VendorMediaFoldersPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorMediaFoldersPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaFoldersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaFoldersPartialUpdate>>>
    export type VendorMediaFoldersPartialUpdateMutationBody = PatchedFolderWriteRequest | undefined
    export type VendorMediaFoldersPartialUpdateMutationError = unknown
    export type VendorMediaFoldersPartialUpdateMutationVariables = {uid: string;data?: PatchedFolderWriteRequest}

    export const useVendorMediaFoldersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersPartialUpdate>>, TError,VendorMediaFoldersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaFoldersPartialUpdate>>,
        TError,
        VendorMediaFoldersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaFoldersPartialUpdateMutationOptions(options), queryClient);
    }
    export type vendorMediaFoldersDestroyResponse204 = {
  data: void
  status: 204
}

export type vendorMediaFoldersDestroyResponseSuccess = (vendorMediaFoldersDestroyResponse204) & {
  headers: Headers;
};
;

export type vendorMediaFoldersDestroyResponse = (vendorMediaFoldersDestroyResponseSuccess)

export const getVendorMediaFoldersDestroyUrl = (uid: string,) => {




  return `/api/v1/vendor/media/folders/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const vendorMediaFoldersDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaFoldersDestroyResponse> => {

  return apiFetch<vendorMediaFoldersDestroyResponse>(getVendorMediaFoldersDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorMediaFoldersDestroyMutationKey = () => ['vendorMediaFoldersDestroy'] as const;

export const getVendorMediaFoldersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersDestroy>>, TError,VendorMediaFoldersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersDestroy>>, TError,VendorMediaFoldersDestroyMutationVariables, TContext> => {

const mutationKey = getVendorMediaFoldersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaFoldersDestroy>>, VendorMediaFoldersDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorMediaFoldersDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaFoldersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaFoldersDestroy>>>

    export type VendorMediaFoldersDestroyMutationError = unknown
    export type VendorMediaFoldersDestroyMutationVariables = {uid: string}

    export const useVendorMediaFoldersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaFoldersDestroy>>, TError,VendorMediaFoldersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaFoldersDestroy>>,
        TError,
        VendorMediaFoldersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaFoldersDestroyMutationOptions(options), queryClient);
    }
    export type vendorMediaVideosCreateResponse201 = {
  data: MediaDetail
  status: 201
}

export type vendorMediaVideosCreateResponseSuccess = (vendorMediaVideosCreateResponse201) & {
  headers: Headers;
};
;

export type vendorMediaVideosCreateResponse = (vendorMediaVideosCreateResponseSuccess)

export const getVendorMediaVideosCreateUrl = () => {




  return `/api/v1/vendor/media/videos`
}

/**
 * Add a YouTube/Vimeo video by link (no file is uploaded).
 */
export const vendorMediaVideosCreate = async (videoRequest: VideoRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorMediaVideosCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorMediaVideosCreateResponse>(getVendorMediaVideosCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(videoRequest)
  }
);}





export const getVendorMediaVideosCreateMutationKey = () => ['vendorMediaVideosCreate'] as const;

export const getVendorMediaVideosCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaVideosCreate>>, TError,VendorMediaVideosCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorMediaVideosCreate>>, TError,VendorMediaVideosCreateMutationVariables, TContext> => {

const mutationKey = getVendorMediaVideosCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorMediaVideosCreate>>, VendorMediaVideosCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorMediaVideosCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorMediaVideosCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorMediaVideosCreate>>>
    export type VendorMediaVideosCreateMutationBody = VideoRequest
    export type VendorMediaVideosCreateMutationError = unknown
    export type VendorMediaVideosCreateMutationVariables = {data: VideoRequest}

    export const useVendorMediaVideosCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorMediaVideosCreate>>, TError,VendorMediaVideosCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorMediaVideosCreate>>,
        TError,
        VendorMediaVideosCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorMediaVideosCreateMutationOptions(options), queryClient);
    }
    export type vendorModulesListResponse200 = {
  data: InstalledModule[]
  status: 200
}

export type vendorModulesListResponseSuccess = (vendorModulesListResponse200) & {
  headers: Headers;
};
;

export type vendorModulesListResponse = (vendorModulesListResponseSuccess)

export const getVendorModulesListUrl = () => {




  return `/api/v1/vendor/modules`
}

/**
 * Modules installed on this server. The frontends hide routes/menus of modules not listed here.
 */
export const vendorModulesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorModulesListResponse> => {

  return apiFetch<vendorModulesListResponse>(getVendorModulesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorModulesListQueryKey = () => {
    return [
    `/api/v1/vendor/modules`
    ] as const;
    }


export const getVendorModulesListQueryOptions = <TData = Awaited<ReturnType<typeof vendorModulesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorModulesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorModulesList>>> = ({ signal }) => vendorModulesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorModulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorModulesListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorModulesList>>>
export type VendorModulesListQueryError = unknown


export function useVendorModulesList<TData = Awaited<ReturnType<typeof vendorModulesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorModulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorModulesList>>,
          TError,
          Awaited<ReturnType<typeof vendorModulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorModulesList<TData = Awaited<ReturnType<typeof vendorModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorModulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorModulesList>>,
          TError,
          Awaited<ReturnType<typeof vendorModulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorModulesList<TData = Awaited<ReturnType<typeof vendorModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorModulesList<TData = Awaited<ReturnType<typeof vendorModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorModulesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorNotificationsListResponse200 = {
  data: PaginatedNotificationList
  status: 200
}

export type vendorNotificationsListResponseSuccess = (vendorNotificationsListResponse200) & {
  headers: Headers;
};
;

export type vendorNotificationsListResponse = (vendorNotificationsListResponseSuccess)

export const getVendorNotificationsListUrl = (params?: VendorNotificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/notifications?${stringifiedParams}` : `/api/v1/vendor/notifications`
}

/**
 * The logged-in user's notifications in this panel, newest first. `?unread=true` for unread only.
 */
export const vendorNotificationsList = async (params?: VendorNotificationsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorNotificationsListResponse> => {

  return apiFetch<vendorNotificationsListResponse>(getVendorNotificationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorNotificationsListQueryKey = (params?: VendorNotificationsListParams,) => {
    return [
    `/api/v1/vendor/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorNotificationsList>>, TError = unknown>(params?: VendorNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorNotificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorNotificationsList>>> = ({ signal }) => vendorNotificationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorNotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorNotificationsList>>>
export type VendorNotificationsListQueryError = unknown


export function useVendorNotificationsList<TData = Awaited<ReturnType<typeof vendorNotificationsList>>, TError = unknown>(
 params: undefined |  VendorNotificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorNotificationsList>>,
          TError,
          Awaited<ReturnType<typeof vendorNotificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorNotificationsList<TData = Awaited<ReturnType<typeof vendorNotificationsList>>, TError = unknown>(
 params?: VendorNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorNotificationsList>>,
          TError,
          Awaited<ReturnType<typeof vendorNotificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorNotificationsList<TData = Awaited<ReturnType<typeof vendorNotificationsList>>, TError = unknown>(
 params?: VendorNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorNotificationsList<TData = Awaited<ReturnType<typeof vendorNotificationsList>>, TError = unknown>(
 params?: VendorNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorNotificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorNotificationsReadCreateResponse200 = {
  data: Notification
  status: 200
}

export type vendorNotificationsReadCreateResponseSuccess = (vendorNotificationsReadCreateResponse200) & {
  headers: Headers;
};
;

export type vendorNotificationsReadCreateResponse = (vendorNotificationsReadCreateResponseSuccess)

export const getVendorNotificationsReadCreateUrl = (uid: string,) => {




  return `/api/v1/vendor/notifications/${uid}/read`
}

export const vendorNotificationsReadCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorNotificationsReadCreateResponse> => {

  return apiFetch<vendorNotificationsReadCreateResponse>(getVendorNotificationsReadCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorNotificationsReadCreateMutationKey = () => ['vendorNotificationsReadCreate'] as const;

export const getVendorNotificationsReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorNotificationsReadCreate>>, TError,VendorNotificationsReadCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorNotificationsReadCreate>>, TError,VendorNotificationsReadCreateMutationVariables, TContext> => {

const mutationKey = getVendorNotificationsReadCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorNotificationsReadCreate>>, VendorNotificationsReadCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorNotificationsReadCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorNotificationsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorNotificationsReadCreate>>>

    export type VendorNotificationsReadCreateMutationError = unknown
    export type VendorNotificationsReadCreateMutationVariables = {uid: string}

    export const useVendorNotificationsReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorNotificationsReadCreate>>, TError,VendorNotificationsReadCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorNotificationsReadCreate>>,
        TError,
        VendorNotificationsReadCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorNotificationsReadCreateMutationOptions(options), queryClient);
    }
    export type vendorNotificationsReadAllCreateResponse200 = {
  data: MarkedRead
  status: 200
}

export type vendorNotificationsReadAllCreateResponseSuccess = (vendorNotificationsReadAllCreateResponse200) & {
  headers: Headers;
};
;

export type vendorNotificationsReadAllCreateResponse = (vendorNotificationsReadAllCreateResponseSuccess)

export const getVendorNotificationsReadAllCreateUrl = () => {




  return `/api/v1/vendor/notifications/read-all`
}

export const vendorNotificationsReadAllCreate = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorNotificationsReadAllCreateResponse> => {

  return apiFetch<vendorNotificationsReadAllCreateResponse>(getVendorNotificationsReadAllCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorNotificationsReadAllCreateMutationKey = () => ['vendorNotificationsReadAllCreate'] as const;

export const getVendorNotificationsReadAllCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorNotificationsReadAllCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorNotificationsReadAllCreate>>, TError,void, TContext> => {

const mutationKey = getVendorNotificationsReadAllCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorNotificationsReadAllCreate>>, void> = () => {


          return  vendorNotificationsReadAllCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorNotificationsReadAllCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorNotificationsReadAllCreate>>>

    export type VendorNotificationsReadAllCreateMutationError = unknown


    export const useVendorNotificationsReadAllCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorNotificationsReadAllCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorNotificationsReadAllCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getVendorNotificationsReadAllCreateMutationOptions(options), queryClient);
    }
    export type vendorNotificationsUnreadCountRetrieveResponse200 = {
  data: UnreadCount
  status: 200
}

export type vendorNotificationsUnreadCountRetrieveResponseSuccess = (vendorNotificationsUnreadCountRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorNotificationsUnreadCountRetrieveResponse = (vendorNotificationsUnreadCountRetrieveResponseSuccess)

export const getVendorNotificationsUnreadCountRetrieveUrl = () => {




  return `/api/v1/vendor/notifications/unread-count`
}

/**
 * Number for the red badge on the bell (the panels poll it).
 */
export const vendorNotificationsUnreadCountRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorNotificationsUnreadCountRetrieveResponse> => {

  return apiFetch<vendorNotificationsUnreadCountRetrieveResponse>(getVendorNotificationsUnreadCountRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorNotificationsUnreadCountRetrieveQueryKey = () => {
    return [
    `/api/v1/vendor/notifications/unread-count`
    ] as const;
    }


export const getVendorNotificationsUnreadCountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorNotificationsUnreadCountRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>> = ({ signal }) => vendorNotificationsUnreadCountRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorNotificationsUnreadCountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>>
export type VendorNotificationsUnreadCountRetrieveQueryError = unknown


export function useVendorNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorNotificationsUnreadCountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorOrdersListResponse200 = {
  data: PaginatedVendorOrderListList
  status: 200
}

export type vendorOrdersListResponseSuccess = (vendorOrdersListResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersListResponse = (vendorOrdersListResponseSuccess)

export const getVendorOrdersListUrl = (params?: VendorOrdersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/orders?${stringifiedParams}` : `/api/v1/vendor/orders`
}

export const vendorOrdersList = async (params?: VendorOrdersListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersListResponse> => {

  return apiFetch<vendorOrdersListResponse>(getVendorOrdersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorOrdersListQueryKey = (params?: VendorOrdersListParams,) => {
    return [
    `/api/v1/vendor/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof vendorOrdersList>>, TError = unknown>(params?: VendorOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorOrdersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorOrdersList>>> = ({ signal }) => vendorOrdersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersList>>>
export type VendorOrdersListQueryError = unknown


export function useVendorOrdersList<TData = Awaited<ReturnType<typeof vendorOrdersList>>, TError = unknown>(
 params: undefined |  VendorOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersList>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersList<TData = Awaited<ReturnType<typeof vendorOrdersList>>, TError = unknown>(
 params?: VendorOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersList>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersList<TData = Awaited<ReturnType<typeof vendorOrdersList>>, TError = unknown>(
 params?: VendorOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorOrdersList<TData = Awaited<ReturnType<typeof vendorOrdersList>>, TError = unknown>(
 params?: VendorOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorOrdersRetrieveResponse200 = {
  data: VendorOrderDetail
  status: 200
}

export type vendorOrdersRetrieveResponseSuccess = (vendorOrdersRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersRetrieveResponse = (vendorOrdersRetrieveResponseSuccess)

export const getVendorOrdersRetrieveUrl = (number: string,) => {




  return `/api/v1/vendor/orders/${number}`
}

export const vendorOrdersRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersRetrieveResponse> => {

  return apiFetch<vendorOrdersRetrieveResponse>(getVendorOrdersRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorOrdersRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/vendor/orders/${number}`
    ] as const;
    }


export const getVendorOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorOrdersRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorOrdersRetrieve>>> = ({ signal }) => vendorOrdersRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersRetrieve>>>
export type VendorOrdersRetrieveQueryError = unknown


export function useVendorOrdersRetrieve<TData = Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersRetrieve<TData = Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersRetrieve<TData = Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorOrdersRetrieve<TData = Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorOrdersRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorOrdersCancelResponse200 = {
  data: VendorOrderDetail
  status: 200
}

export type vendorOrdersCancelResponseSuccess = (vendorOrdersCancelResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersCancelResponse = (vendorOrdersCancelResponseSuccess)

export const getVendorOrdersCancelUrl = (number: string,) => {




  return `/api/v1/vendor/orders/${number}/cancel`
}

/**
 * Cancel an order the store can't fulfil (before it ships): stock back, customer refunded.
 */
export const vendorOrdersCancel = async (number: string,
    cancelRequest: CancelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersCancelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorOrdersCancelResponse>(getVendorOrdersCancelUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cancelRequest)
  }
);}





export const getVendorOrdersCancelMutationKey = () => ['vendorOrdersCancel'] as const;

export const getVendorOrdersCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersCancel>>, TError,VendorOrdersCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersCancel>>, TError,VendorOrdersCancelMutationVariables, TContext> => {

const mutationKey = getVendorOrdersCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorOrdersCancel>>, VendorOrdersCancelMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  vendorOrdersCancel(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorOrdersCancelMutationResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersCancel>>>
    export type VendorOrdersCancelMutationBody = CancelRequest
    export type VendorOrdersCancelMutationError = unknown
    export type VendorOrdersCancelMutationVariables = {number: string;data: CancelRequest}

    export const useVendorOrdersCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersCancel>>, TError,VendorOrdersCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorOrdersCancel>>,
        TError,
        VendorOrdersCancelMutationVariables,
        TContext
      > => {
      return useMutation(getVendorOrdersCancelMutationOptions(options), queryClient);
    }
    export type vendorOrdersStatusResponse200 = {
  data: VendorOrderDetail
  status: 200
}

export type vendorOrdersStatusResponseSuccess = (vendorOrdersStatusResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersStatusResponse = (vendorOrdersStatusResponseSuccess)

export const getVendorOrdersStatusUrl = (number: string,) => {




  return `/api/v1/vendor/orders/${number}/status`
}

/**
 * Move the order to its next status (shipping needs the courier and tracking number).
 */
export const vendorOrdersStatus = async (number: string,
    advanceRequest: AdvanceRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersStatusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorOrdersStatusResponse>(getVendorOrdersStatusUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(advanceRequest)
  }
);}





export const getVendorOrdersStatusMutationKey = () => ['vendorOrdersStatus'] as const;

export const getVendorOrdersStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersStatus>>, TError,VendorOrdersStatusMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersStatus>>, TError,VendorOrdersStatusMutationVariables, TContext> => {

const mutationKey = getVendorOrdersStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorOrdersStatus>>, VendorOrdersStatusMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  vendorOrdersStatus(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorOrdersStatusMutationResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersStatus>>>
    export type VendorOrdersStatusMutationBody = AdvanceRequest
    export type VendorOrdersStatusMutationError = unknown
    export type VendorOrdersStatusMutationVariables = {number: string;data: AdvanceRequest}

    export const useVendorOrdersStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersStatus>>, TError,VendorOrdersStatusMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorOrdersStatus>>,
        TError,
        VendorOrdersStatusMutationVariables,
        TContext
      > => {
      return useMutation(getVendorOrdersStatusMutationOptions(options), queryClient);
    }
    export type vendorOrdersTrackingResponse200 = {
  data: VendorOrderDetail
  status: 200
}

export type vendorOrdersTrackingResponseSuccess = (vendorOrdersTrackingResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersTrackingResponse = (vendorOrdersTrackingResponseSuccess)

export const getVendorOrdersTrackingUrl = (number: string,) => {




  return `/api/v1/vendor/orders/${number}/tracking`
}

/**
 * Correct the courier / tracking number of a shipped order.
 */
export const vendorOrdersTracking = async (number: string,
    trackingRequest: TrackingRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersTrackingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorOrdersTrackingResponse>(getVendorOrdersTrackingUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trackingRequest)
  }
);}





export const getVendorOrdersTrackingMutationKey = () => ['vendorOrdersTracking'] as const;

export const getVendorOrdersTrackingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersTracking>>, TError,VendorOrdersTrackingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersTracking>>, TError,VendorOrdersTrackingMutationVariables, TContext> => {

const mutationKey = getVendorOrdersTrackingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorOrdersTracking>>, VendorOrdersTrackingMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  vendorOrdersTracking(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorOrdersTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersTracking>>>
    export type VendorOrdersTrackingMutationBody = TrackingRequest
    export type VendorOrdersTrackingMutationError = unknown
    export type VendorOrdersTrackingMutationVariables = {number: string;data: TrackingRequest}

    export const useVendorOrdersTracking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorOrdersTracking>>, TError,VendorOrdersTrackingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorOrdersTracking>>,
        TError,
        VendorOrdersTrackingMutationVariables,
        TContext
      > => {
      return useMutation(getVendorOrdersTrackingMutationOptions(options), queryClient);
    }
    export type vendorOrdersCountsResponse200 = {
  data: StatusCounts
  status: 200
}

export type vendorOrdersCountsResponseSuccess = (vendorOrdersCountsResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersCountsResponse = (vendorOrdersCountsResponseSuccess)

export const getVendorOrdersCountsUrl = () => {




  return `/api/v1/vendor/orders/counts`
}

export const vendorOrdersCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersCountsResponse> => {

  return apiFetch<vendorOrdersCountsResponse>(getVendorOrdersCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorOrdersCountsQueryKey = () => {
    return [
    `/api/v1/vendor/orders/counts`
    ] as const;
    }


export const getVendorOrdersCountsQueryOptions = <TData = Awaited<ReturnType<typeof vendorOrdersCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorOrdersCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorOrdersCounts>>> = ({ signal }) => vendorOrdersCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorOrdersCountsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersCounts>>>
export type VendorOrdersCountsQueryError = unknown


export function useVendorOrdersCounts<TData = Awaited<ReturnType<typeof vendorOrdersCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersCounts>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersCounts<TData = Awaited<ReturnType<typeof vendorOrdersCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersCounts>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersCounts<TData = Awaited<ReturnType<typeof vendorOrdersCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorOrdersCounts<TData = Awaited<ReturnType<typeof vendorOrdersCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorOrdersCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorOrdersSummaryResponse200 = {
  data: StoreSummary
  status: 200
}

export type vendorOrdersSummaryResponseSuccess = (vendorOrdersSummaryResponse200) & {
  headers: Headers;
};
;

export type vendorOrdersSummaryResponse = (vendorOrdersSummaryResponseSuccess)

export const getVendorOrdersSummaryUrl = () => {




  return `/api/v1/vendor/orders/summary`
}

export const vendorOrdersSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorOrdersSummaryResponse> => {

  return apiFetch<vendorOrdersSummaryResponse>(getVendorOrdersSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorOrdersSummaryQueryKey = () => {
    return [
    `/api/v1/vendor/orders/summary`
    ] as const;
    }


export const getVendorOrdersSummaryQueryOptions = <TData = Awaited<ReturnType<typeof vendorOrdersSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorOrdersSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorOrdersSummary>>> = ({ signal }) => vendorOrdersSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorOrdersSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof vendorOrdersSummary>>>
export type VendorOrdersSummaryQueryError = unknown


export function useVendorOrdersSummary<TData = Awaited<ReturnType<typeof vendorOrdersSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersSummary>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersSummary<TData = Awaited<ReturnType<typeof vendorOrdersSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorOrdersSummary>>,
          TError,
          Awaited<ReturnType<typeof vendorOrdersSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorOrdersSummary<TData = Awaited<ReturnType<typeof vendorOrdersSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorOrdersSummary<TData = Awaited<ReturnType<typeof vendorOrdersSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorOrdersSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorOrdersSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorProductsListResponse200 = {
  data: PaginatedProductListList
  status: 200
}

export type vendorProductsListResponseSuccess = (vendorProductsListResponse200) & {
  headers: Headers;
};
;

export type vendorProductsListResponse = (vendorProductsListResponseSuccess)

export const getVendorProductsListUrl = (params?: VendorProductsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/products?${stringifiedParams}` : `/api/v1/vendor/products`
}

export const vendorProductsList = async (params?: VendorProductsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsListResponse> => {

  return apiFetch<vendorProductsListResponse>(getVendorProductsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorProductsListQueryKey = (params?: VendorProductsListParams,) => {
    return [
    `/api/v1/vendor/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorProductsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorProductsList>>, TError = unknown>(params?: VendorProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorProductsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorProductsList>>> = ({ signal }) => vendorProductsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorProductsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorProductsList>>>
export type VendorProductsListQueryError = unknown


export function useVendorProductsList<TData = Awaited<ReturnType<typeof vendorProductsList>>, TError = unknown>(
 params: undefined |  VendorProductsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsList>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsList<TData = Awaited<ReturnType<typeof vendorProductsList>>, TError = unknown>(
 params?: VendorProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsList>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsList<TData = Awaited<ReturnType<typeof vendorProductsList>>, TError = unknown>(
 params?: VendorProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorProductsList<TData = Awaited<ReturnType<typeof vendorProductsList>>, TError = unknown>(
 params?: VendorProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorProductsCreateResponse201 = {
  data: ProductDetail
  status: 201
}

export type vendorProductsCreateResponseSuccess = (vendorProductsCreateResponse201) & {
  headers: Headers;
};
;

export type vendorProductsCreateResponse = (vendorProductsCreateResponseSuccess)

export const getVendorProductsCreateUrl = () => {




  return `/api/v1/vendor/products`
}

/**
 * A new product of this store, saved as a draft (submit it when it's complete).
 */
export const vendorProductsCreate = async (productWriteRequest?: ProductWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorProductsCreateResponse>(getVendorProductsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productWriteRequest)
  }
);}





export const getVendorProductsCreateMutationKey = () => ['vendorProductsCreate'] as const;

export const getVendorProductsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsCreate>>, TError,VendorProductsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorProductsCreate>>, TError,VendorProductsCreateMutationVariables, TContext> => {

const mutationKey = getVendorProductsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorProductsCreate>>, VendorProductsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorProductsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorProductsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorProductsCreate>>>
    export type VendorProductsCreateMutationBody = ProductWriteRequest | undefined
    export type VendorProductsCreateMutationError = unknown
    export type VendorProductsCreateMutationVariables = {data?: ProductWriteRequest}

    export const useVendorProductsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsCreate>>, TError,VendorProductsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorProductsCreate>>,
        TError,
        VendorProductsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorProductsCreateMutationOptions(options), queryClient);
    }
    export type vendorProductsRetrieveResponse200 = {
  data: ProductDetail
  status: 200
}

export type vendorProductsRetrieveResponseSuccess = (vendorProductsRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorProductsRetrieveResponse = (vendorProductsRetrieveResponseSuccess)

export const getVendorProductsRetrieveUrl = (uid: string,) => {




  return `/api/v1/vendor/products/${uid}`
}

export const vendorProductsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsRetrieveResponse> => {

  return apiFetch<vendorProductsRetrieveResponse>(getVendorProductsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorProductsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/products/${uid}`
    ] as const;
    }


export const getVendorProductsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorProductsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorProductsRetrieve>>> = ({ signal }) => vendorProductsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorProductsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorProductsRetrieve>>>
export type VendorProductsRetrieveQueryError = unknown


export function useVendorProductsRetrieve<TData = Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsRetrieve<TData = Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsRetrieve<TData = Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorProductsRetrieve<TData = Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorProductsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorProductsPartialUpdateResponse200 = {
  data: ProductDetail
  status: 200
}

export type vendorProductsPartialUpdateResponseSuccess = (vendorProductsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorProductsPartialUpdateResponse = (vendorProductsPartialUpdateResponseSuccess)

export const getVendorProductsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/vendor/products/${uid}`
}

export const vendorProductsPartialUpdate = async (uid: string,
    patchedProductWriteRequest?: PatchedProductWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorProductsPartialUpdateResponse>(getVendorProductsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProductWriteRequest)
  }
);}





export const getVendorProductsPartialUpdateMutationKey = () => ['vendorProductsPartialUpdate'] as const;

export const getVendorProductsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsPartialUpdate>>, TError,VendorProductsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorProductsPartialUpdate>>, TError,VendorProductsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getVendorProductsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorProductsPartialUpdate>>, VendorProductsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorProductsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorProductsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorProductsPartialUpdate>>>
    export type VendorProductsPartialUpdateMutationBody = PatchedProductWriteRequest | undefined
    export type VendorProductsPartialUpdateMutationError = unknown
    export type VendorProductsPartialUpdateMutationVariables = {uid: string;data?: PatchedProductWriteRequest}

    export const useVendorProductsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsPartialUpdate>>, TError,VendorProductsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorProductsPartialUpdate>>,
        TError,
        VendorProductsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorProductsPartialUpdateMutationOptions(options), queryClient);
    }
    export type vendorProductsDestroyResponse204 = {
  data: void
  status: 204
}

export type vendorProductsDestroyResponseSuccess = (vendorProductsDestroyResponse204) & {
  headers: Headers;
};
;

export type vendorProductsDestroyResponse = (vendorProductsDestroyResponseSuccess)

export const getVendorProductsDestroyUrl = (uid: string,) => {




  return `/api/v1/vendor/products/${uid}`
}

export const vendorProductsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsDestroyResponse> => {

  return apiFetch<vendorProductsDestroyResponse>(getVendorProductsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorProductsDestroyMutationKey = () => ['vendorProductsDestroy'] as const;

export const getVendorProductsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsDestroy>>, TError,VendorProductsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorProductsDestroy>>, TError,VendorProductsDestroyMutationVariables, TContext> => {

const mutationKey = getVendorProductsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorProductsDestroy>>, VendorProductsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorProductsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorProductsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof vendorProductsDestroy>>>

    export type VendorProductsDestroyMutationError = unknown
    export type VendorProductsDestroyMutationVariables = {uid: string}

    export const useVendorProductsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsDestroy>>, TError,VendorProductsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorProductsDestroy>>,
        TError,
        VendorProductsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getVendorProductsDestroyMutationOptions(options), queryClient);
    }
    export type vendorProductsHistoryResponse200 = {
  data: ProductHistory[]
  status: 200
}

export type vendorProductsHistoryResponseSuccess = (vendorProductsHistoryResponse200) & {
  headers: Headers;
};
;

export type vendorProductsHistoryResponse = (vendorProductsHistoryResponseSuccess)

export const getVendorProductsHistoryUrl = (uid: string,) => {




  return `/api/v1/vendor/products/${uid}/history`
}

export const vendorProductsHistory = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsHistoryResponse> => {

  return apiFetch<vendorProductsHistoryResponse>(getVendorProductsHistoryUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorProductsHistoryQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/products/${uid}/history`
    ] as const;
    }


export const getVendorProductsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof vendorProductsHistory>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorProductsHistoryQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorProductsHistory>>> = ({ signal }) => vendorProductsHistory(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorProductsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorProductsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof vendorProductsHistory>>>
export type VendorProductsHistoryQueryError = unknown


export function useVendorProductsHistory<TData = Awaited<ReturnType<typeof vendorProductsHistory>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsHistory>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsHistory<TData = Awaited<ReturnType<typeof vendorProductsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsHistory>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsHistory<TData = Awaited<ReturnType<typeof vendorProductsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorProductsHistory<TData = Awaited<ReturnType<typeof vendorProductsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorProductsHistoryQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorProductsPublishResponse200 = {
  data: ProductDetail
  status: 200
}

export type vendorProductsPublishResponseSuccess = (vendorProductsPublishResponse200) & {
  headers: Headers;
};
;

export type vendorProductsPublishResponse = (vendorProductsPublishResponseSuccess)

export const getVendorProductsPublishUrl = (uid: string,) => {




  return `/api/v1/vendor/products/${uid}/publish`
}

export const vendorProductsPublish = async (uid: string,
    vendorProductPublishRequest: VendorProductPublishRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsPublishResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorProductsPublishResponse>(getVendorProductsPublishUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorProductPublishRequest)
  }
);}





export const getVendorProductsPublishMutationKey = () => ['vendorProductsPublish'] as const;

export const getVendorProductsPublishMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsPublish>>, TError,VendorProductsPublishMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorProductsPublish>>, TError,VendorProductsPublishMutationVariables, TContext> => {

const mutationKey = getVendorProductsPublishMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorProductsPublish>>, VendorProductsPublishMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorProductsPublish(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorProductsPublishMutationResult = NonNullable<Awaited<ReturnType<typeof vendorProductsPublish>>>
    export type VendorProductsPublishMutationBody = VendorProductPublishRequest
    export type VendorProductsPublishMutationError = unknown
    export type VendorProductsPublishMutationVariables = {uid: string;data: VendorProductPublishRequest}

    export const useVendorProductsPublish = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsPublish>>, TError,VendorProductsPublishMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorProductsPublish>>,
        TError,
        VendorProductsPublishMutationVariables,
        TContext
      > => {
      return useMutation(getVendorProductsPublishMutationOptions(options), queryClient);
    }
    export type vendorProductsSubmitResponse200 = {
  data: ProductDetail
  status: 200
}

export type vendorProductsSubmitResponseSuccess = (vendorProductsSubmitResponse200) & {
  headers: Headers;
};
;

export type vendorProductsSubmitResponse = (vendorProductsSubmitResponseSuccess)

export const getVendorProductsSubmitUrl = (uid: string,) => {




  return `/api/v1/vendor/products/${uid}/submit`
}

export const vendorProductsSubmit = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsSubmitResponse> => {

  return apiFetch<vendorProductsSubmitResponse>(getVendorProductsSubmitUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorProductsSubmitMutationKey = () => ['vendorProductsSubmit'] as const;

export const getVendorProductsSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsSubmit>>, TError,VendorProductsSubmitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorProductsSubmit>>, TError,VendorProductsSubmitMutationVariables, TContext> => {

const mutationKey = getVendorProductsSubmitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorProductsSubmit>>, VendorProductsSubmitMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorProductsSubmit(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorProductsSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof vendorProductsSubmit>>>

    export type VendorProductsSubmitMutationError = unknown
    export type VendorProductsSubmitMutationVariables = {uid: string}

    export const useVendorProductsSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsSubmit>>, TError,VendorProductsSubmitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorProductsSubmit>>,
        TError,
        VendorProductsSubmitMutationVariables,
        TContext
      > => {
      return useMutation(getVendorProductsSubmitMutationOptions(options), queryClient);
    }
    export type vendorProductsBulkPublishResponse200 = {
  data: VendorBulkPublishResult
  status: 200
}

export type vendorProductsBulkPublishResponseSuccess = (vendorProductsBulkPublishResponse200) & {
  headers: Headers;
};
;

export type vendorProductsBulkPublishResponse = (vendorProductsBulkPublishResponseSuccess)

export const getVendorProductsBulkPublishUrl = () => {




  return `/api/v1/vendor/products/bulk-publish`
}

export const vendorProductsBulkPublish = async (vendorBulkPublishRequest: VendorBulkPublishRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsBulkPublishResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorProductsBulkPublishResponse>(getVendorProductsBulkPublishUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorBulkPublishRequest)
  }
);}





export const getVendorProductsBulkPublishMutationKey = () => ['vendorProductsBulkPublish'] as const;

export const getVendorProductsBulkPublishMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsBulkPublish>>, TError,VendorProductsBulkPublishMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorProductsBulkPublish>>, TError,VendorProductsBulkPublishMutationVariables, TContext> => {

const mutationKey = getVendorProductsBulkPublishMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorProductsBulkPublish>>, VendorProductsBulkPublishMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorProductsBulkPublish(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorProductsBulkPublishMutationResult = NonNullable<Awaited<ReturnType<typeof vendorProductsBulkPublish>>>
    export type VendorProductsBulkPublishMutationBody = VendorBulkPublishRequest
    export type VendorProductsBulkPublishMutationError = unknown
    export type VendorProductsBulkPublishMutationVariables = {data: VendorBulkPublishRequest}

    export const useVendorProductsBulkPublish = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorProductsBulkPublish>>, TError,VendorProductsBulkPublishMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorProductsBulkPublish>>,
        TError,
        VendorProductsBulkPublishMutationVariables,
        TContext
      > => {
      return useMutation(getVendorProductsBulkPublishMutationOptions(options), queryClient);
    }
    export type vendorProductsCountsResponse200 = {
  data: ProductStatusCounts
  status: 200
}

export type vendorProductsCountsResponseSuccess = (vendorProductsCountsResponse200) & {
  headers: Headers;
};
;

export type vendorProductsCountsResponse = (vendorProductsCountsResponseSuccess)

export const getVendorProductsCountsUrl = () => {




  return `/api/v1/vendor/products/counts`
}

export const vendorProductsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsCountsResponse> => {

  return apiFetch<vendorProductsCountsResponse>(getVendorProductsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorProductsCountsQueryKey = () => {
    return [
    `/api/v1/vendor/products/counts`
    ] as const;
    }


export const getVendorProductsCountsQueryOptions = <TData = Awaited<ReturnType<typeof vendorProductsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorProductsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorProductsCounts>>> = ({ signal }) => vendorProductsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorProductsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorProductsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorProductsCounts>>>
export type VendorProductsCountsQueryError = unknown


export function useVendorProductsCounts<TData = Awaited<ReturnType<typeof vendorProductsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsCounts>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsCounts<TData = Awaited<ReturnType<typeof vendorProductsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsCounts>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsCounts<TData = Awaited<ReturnType<typeof vendorProductsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorProductsCounts<TData = Awaited<ReturnType<typeof vendorProductsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorProductsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorProductsSettingsResponse200 = {
  data: ApprovalSettings
  status: 200
}

export type vendorProductsSettingsResponseSuccess = (vendorProductsSettingsResponse200) & {
  headers: Headers;
};
;

export type vendorProductsSettingsResponse = (vendorProductsSettingsResponseSuccess)

export const getVendorProductsSettingsUrl = () => {




  return `/api/v1/vendor/products/settings`
}

export const vendorProductsSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorProductsSettingsResponse> => {

  return apiFetch<vendorProductsSettingsResponse>(getVendorProductsSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorProductsSettingsQueryKey = () => {
    return [
    `/api/v1/vendor/products/settings`
    ] as const;
    }


export const getVendorProductsSettingsQueryOptions = <TData = Awaited<ReturnType<typeof vendorProductsSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorProductsSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorProductsSettings>>> = ({ signal }) => vendorProductsSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorProductsSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorProductsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorProductsSettings>>>
export type VendorProductsSettingsQueryError = unknown


export function useVendorProductsSettings<TData = Awaited<ReturnType<typeof vendorProductsSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsSettings>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsSettings<TData = Awaited<ReturnType<typeof vendorProductsSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorProductsSettings>>,
          TError,
          Awaited<ReturnType<typeof vendorProductsSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorProductsSettings<TData = Awaited<ReturnType<typeof vendorProductsSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorProductsSettings<TData = Awaited<ReturnType<typeof vendorProductsSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorProductsSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorProductsSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReportsExportsListResponse200 = {
  data: Export[]
  status: 200
}

export type vendorReportsExportsListResponseSuccess = (vendorReportsExportsListResponse200) & {
  headers: Headers;
};
;

export type vendorReportsExportsListResponse = (vendorReportsExportsListResponseSuccess)

export const getVendorReportsExportsListUrl = () => {




  return `/api/v1/vendor/reports/exports`
}

export const vendorReportsExportsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorReportsExportsListResponse> => {

  return apiFetch<vendorReportsExportsListResponse>(getVendorReportsExportsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReportsExportsListQueryKey = () => {
    return [
    `/api/v1/vendor/reports/exports`
    ] as const;
    }


export const getVendorReportsExportsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorReportsExportsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReportsExportsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReportsExportsList>>> = ({ signal }) => vendorReportsExportsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReportsExportsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReportsExportsList>>>
export type VendorReportsExportsListQueryError = unknown


export function useVendorReportsExportsList<TData = Awaited<ReturnType<typeof vendorReportsExportsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReportsExportsList>>,
          TError,
          Awaited<ReturnType<typeof vendorReportsExportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReportsExportsList<TData = Awaited<ReturnType<typeof vendorReportsExportsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReportsExportsList>>,
          TError,
          Awaited<ReturnType<typeof vendorReportsExportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReportsExportsList<TData = Awaited<ReturnType<typeof vendorReportsExportsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReportsExportsList<TData = Awaited<ReturnType<typeof vendorReportsExportsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReportsExportsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReportsExportsCreateResponse201 = {
  data: Export
  status: 201
}

export type vendorReportsExportsCreateResponseSuccess = (vendorReportsExportsCreateResponse201) & {
  headers: Headers;
};
;

export type vendorReportsExportsCreateResponse = (vendorReportsExportsCreateResponseSuccess)

export const getVendorReportsExportsCreateUrl = () => {




  return `/api/v1/vendor/reports/exports`
}

export const vendorReportsExportsCreate = async (exportRequestRequest: ExportRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReportsExportsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorReportsExportsCreateResponse>(getVendorReportsExportsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(exportRequestRequest)
  }
);}





export const getVendorReportsExportsCreateMutationKey = () => ['vendorReportsExportsCreate'] as const;

export const getVendorReportsExportsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorReportsExportsCreate>>, TError,VendorReportsExportsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorReportsExportsCreate>>, TError,VendorReportsExportsCreateMutationVariables, TContext> => {

const mutationKey = getVendorReportsExportsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorReportsExportsCreate>>, VendorReportsExportsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorReportsExportsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorReportsExportsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorReportsExportsCreate>>>
    export type VendorReportsExportsCreateMutationBody = ExportRequestRequest
    export type VendorReportsExportsCreateMutationError = unknown
    export type VendorReportsExportsCreateMutationVariables = {data: ExportRequestRequest}

    export const useVendorReportsExportsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorReportsExportsCreate>>, TError,VendorReportsExportsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorReportsExportsCreate>>,
        TError,
        VendorReportsExportsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorReportsExportsCreateMutationOptions(options), queryClient);
    }
    export type vendorReportsExportsFileResponse200 = {
  data: Blob
  status: 200
}

export type vendorReportsExportsFileResponseSuccess = (vendorReportsExportsFileResponse200) & {
  headers: Headers;
};
;

export type vendorReportsExportsFileResponse = (vendorReportsExportsFileResponseSuccess)

export const getVendorReportsExportsFileUrl = (uid: string,) => {




  return `/api/v1/vendor/reports/exports/${uid}/file`
}

export const vendorReportsExportsFile = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReportsExportsFileResponse> => {

  return apiFetch<vendorReportsExportsFileResponse>(getVendorReportsExportsFileUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReportsExportsFileQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/reports/exports/${uid}/file`
    ] as const;
    }


export const getVendorReportsExportsFileQueryOptions = <TData = Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReportsExportsFileQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReportsExportsFile>>> = ({ signal }) => vendorReportsExportsFile(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReportsExportsFileQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReportsExportsFile>>>
export type VendorReportsExportsFileQueryError = unknown


export function useVendorReportsExportsFile<TData = Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReportsExportsFile>>,
          TError,
          Awaited<ReturnType<typeof vendorReportsExportsFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReportsExportsFile<TData = Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReportsExportsFile>>,
          TError,
          Awaited<ReturnType<typeof vendorReportsExportsFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReportsExportsFile<TData = Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReportsExportsFile<TData = Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsExportsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReportsExportsFileQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReportsOverviewResponse200 = {
  data: Overview
  status: 200
}

export type vendorReportsOverviewResponseSuccess = (vendorReportsOverviewResponse200) & {
  headers: Headers;
};
;

export type vendorReportsOverviewResponse = (vendorReportsOverviewResponseSuccess)

export const getVendorReportsOverviewUrl = (params?: VendorReportsOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/reports/overview?${stringifiedParams}` : `/api/v1/vendor/reports/overview`
}

export const vendorReportsOverview = async (params?: VendorReportsOverviewParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReportsOverviewResponse> => {

  return apiFetch<vendorReportsOverviewResponse>(getVendorReportsOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReportsOverviewQueryKey = (params?: VendorReportsOverviewParams,) => {
    return [
    `/api/v1/vendor/reports/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorReportsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof vendorReportsOverview>>, TError = unknown>(params?: VendorReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReportsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReportsOverview>>> = ({ signal }) => vendorReportsOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReportsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReportsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReportsOverview>>>
export type VendorReportsOverviewQueryError = unknown


export function useVendorReportsOverview<TData = Awaited<ReturnType<typeof vendorReportsOverview>>, TError = unknown>(
 params: undefined |  VendorReportsOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof vendorReportsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReportsOverview<TData = Awaited<ReturnType<typeof vendorReportsOverview>>, TError = unknown>(
 params?: VendorReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof vendorReportsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReportsOverview<TData = Awaited<ReturnType<typeof vendorReportsOverview>>, TError = unknown>(
 params?: VendorReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReportsOverview<TData = Awaited<ReturnType<typeof vendorReportsOverview>>, TError = unknown>(
 params?: VendorReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReportsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReturnsListResponse200 = {
  data: PaginatedReturnListList
  status: 200
}

export type vendorReturnsListResponseSuccess = (vendorReturnsListResponse200) & {
  headers: Headers;
};
;

export type vendorReturnsListResponse = (vendorReturnsListResponseSuccess)

export const getVendorReturnsListUrl = (params?: VendorReturnsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/returns?${stringifiedParams}` : `/api/v1/vendor/returns`
}

export const vendorReturnsList = async (params?: VendorReturnsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReturnsListResponse> => {

  return apiFetch<vendorReturnsListResponse>(getVendorReturnsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReturnsListQueryKey = (params?: VendorReturnsListParams,) => {
    return [
    `/api/v1/vendor/returns`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorReturnsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorReturnsList>>, TError = unknown>(params?: VendorReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReturnsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReturnsList>>> = ({ signal }) => vendorReturnsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReturnsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReturnsList>>>
export type VendorReturnsListQueryError = unknown


export function useVendorReturnsList<TData = Awaited<ReturnType<typeof vendorReturnsList>>, TError = unknown>(
 params: undefined |  VendorReturnsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsList>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsList<TData = Awaited<ReturnType<typeof vendorReturnsList>>, TError = unknown>(
 params?: VendorReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsList>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsList<TData = Awaited<ReturnType<typeof vendorReturnsList>>, TError = unknown>(
 params?: VendorReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReturnsList<TData = Awaited<ReturnType<typeof vendorReturnsList>>, TError = unknown>(
 params?: VendorReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReturnsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReturnsRetrieveResponse200 = {
  data: ReturnDetail
  status: 200
}

export type vendorReturnsRetrieveResponseSuccess = (vendorReturnsRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorReturnsRetrieveResponse = (vendorReturnsRetrieveResponseSuccess)

export const getVendorReturnsRetrieveUrl = (number: string,) => {




  return `/api/v1/vendor/returns/${number}`
}

export const vendorReturnsRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReturnsRetrieveResponse> => {

  return apiFetch<vendorReturnsRetrieveResponse>(getVendorReturnsRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReturnsRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/vendor/returns/${number}`
    ] as const;
    }


export const getVendorReturnsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReturnsRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReturnsRetrieve>>> = ({ signal }) => vendorReturnsRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReturnsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReturnsRetrieve>>>
export type VendorReturnsRetrieveQueryError = unknown


export function useVendorReturnsRetrieve<TData = Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsRetrieve<TData = Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsRetrieve<TData = Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReturnsRetrieve<TData = Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReturnsRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReturnsActResponse200 = {
  data: ReturnDetail
  status: 200
}

export type vendorReturnsActResponseSuccess = (vendorReturnsActResponse200) & {
  headers: Headers;
};
;

export type vendorReturnsActResponse = (vendorReturnsActResponseSuccess)

export const getVendorReturnsActUrl = (number: string,) => {




  return `/api/v1/vendor/returns/${number}/act`
}

export const vendorReturnsAct = async (number: string,
    actRequest: ActRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReturnsActResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorReturnsActResponse>(getVendorReturnsActUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(actRequest)
  }
);}





export const getVendorReturnsActMutationKey = () => ['vendorReturnsAct'] as const;

export const getVendorReturnsActMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorReturnsAct>>, TError,VendorReturnsActMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorReturnsAct>>, TError,VendorReturnsActMutationVariables, TContext> => {

const mutationKey = getVendorReturnsActMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorReturnsAct>>, VendorReturnsActMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  vendorReturnsAct(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorReturnsActMutationResult = NonNullable<Awaited<ReturnType<typeof vendorReturnsAct>>>
    export type VendorReturnsActMutationBody = ActRequest
    export type VendorReturnsActMutationError = unknown
    export type VendorReturnsActMutationVariables = {number: string;data: ActRequest}

    export const useVendorReturnsAct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorReturnsAct>>, TError,VendorReturnsActMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorReturnsAct>>,
        TError,
        VendorReturnsActMutationVariables,
        TContext
      > => {
      return useMutation(getVendorReturnsActMutationOptions(options), queryClient);
    }
    export type vendorReturnsPhotoResponse200 = {
  data: Blob
  status: 200
}

export type vendorReturnsPhotoResponseSuccess = (vendorReturnsPhotoResponse200) & {
  headers: Headers;
};
;

export type vendorReturnsPhotoResponse = (vendorReturnsPhotoResponseSuccess)

export const getVendorReturnsPhotoUrl = (number: string,
    mediaUid: string,) => {




  return `/api/v1/vendor/returns/${number}/photos/${mediaUid}`
}

export const vendorReturnsPhoto = async (number: string,
    mediaUid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorReturnsPhotoResponse> => {

  return apiFetch<vendorReturnsPhotoResponse>(getVendorReturnsPhotoUrl(number,mediaUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReturnsPhotoQueryKey = (number: string,
    mediaUid: string,) => {
    return [
    `/api/v1/vendor/returns/${number}/photos/${mediaUid}`
    ] as const;
    }


export const getVendorReturnsPhotoQueryOptions = <TData = Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError = unknown>(number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReturnsPhotoQueryKey(number,mediaUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReturnsPhoto>>> = ({ signal }) => vendorReturnsPhoto(number,mediaUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && mediaUid !== null && mediaUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReturnsPhotoQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReturnsPhoto>>>
export type VendorReturnsPhotoQueryError = unknown


export function useVendorReturnsPhoto<TData = Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsPhoto>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsPhoto<TData = Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsPhoto>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsPhoto<TData = Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReturnsPhoto<TData = Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReturnsPhotoQueryOptions(number,mediaUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorReturnsCountsResponse200 = {
  data: ReturnCounts
  status: 200
}

export type vendorReturnsCountsResponseSuccess = (vendorReturnsCountsResponse200) & {
  headers: Headers;
};
;

export type vendorReturnsCountsResponse = (vendorReturnsCountsResponseSuccess)

export const getVendorReturnsCountsUrl = () => {




  return `/api/v1/vendor/returns/counts`
}

export const vendorReturnsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorReturnsCountsResponse> => {

  return apiFetch<vendorReturnsCountsResponse>(getVendorReturnsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorReturnsCountsQueryKey = () => {
    return [
    `/api/v1/vendor/returns/counts`
    ] as const;
    }


export const getVendorReturnsCountsQueryOptions = <TData = Awaited<ReturnType<typeof vendorReturnsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorReturnsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorReturnsCounts>>> = ({ signal }) => vendorReturnsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorReturnsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorReturnsCounts>>>
export type VendorReturnsCountsQueryError = unknown


export function useVendorReturnsCounts<TData = Awaited<ReturnType<typeof vendorReturnsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsCounts>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsCounts<TData = Awaited<ReturnType<typeof vendorReturnsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorReturnsCounts>>,
          TError,
          Awaited<ReturnType<typeof vendorReturnsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorReturnsCounts<TData = Awaited<ReturnType<typeof vendorReturnsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorReturnsCounts<TData = Awaited<ReturnType<typeof vendorReturnsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorReturnsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorReturnsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStockListResponse200 = {
  data: PaginatedStockRowList
  status: 200
}

export type vendorStockListResponseSuccess = (vendorStockListResponse200) & {
  headers: Headers;
};
;

export type vendorStockListResponse = (vendorStockListResponseSuccess)

export const getVendorStockListUrl = (params?: VendorStockListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/stock?${stringifiedParams}` : `/api/v1/vendor/stock`
}

export const vendorStockList = async (params?: VendorStockListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockListResponse> => {

  return apiFetch<vendorStockListResponse>(getVendorStockListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStockListQueryKey = (params?: VendorStockListParams,) => {
    return [
    `/api/v1/vendor/stock`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorStockListQueryOptions = <TData = Awaited<ReturnType<typeof vendorStockList>>, TError = unknown>(params?: VendorStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStockListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStockList>>> = ({ signal }) => vendorStockList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStockList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStockListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStockList>>>
export type VendorStockListQueryError = unknown


export function useVendorStockList<TData = Awaited<ReturnType<typeof vendorStockList>>, TError = unknown>(
 params: undefined |  VendorStockListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockList>>,
          TError,
          Awaited<ReturnType<typeof vendorStockList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockList<TData = Awaited<ReturnType<typeof vendorStockList>>, TError = unknown>(
 params?: VendorStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockList>>,
          TError,
          Awaited<ReturnType<typeof vendorStockList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockList<TData = Awaited<ReturnType<typeof vendorStockList>>, TError = unknown>(
 params?: VendorStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStockList<TData = Awaited<ReturnType<typeof vendorStockList>>, TError = unknown>(
 params?: VendorStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStockListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStockUpdateResponse200 = {
  data: StockRow
  status: 200
}

export type vendorStockUpdateResponseSuccess = (vendorStockUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorStockUpdateResponse = (vendorStockUpdateResponseSuccess)

export const getVendorStockUpdateUrl = (uid: string,) => {




  return `/api/v1/vendor/stock/${uid}`
}

export const vendorStockUpdate = async (uid: string,
    patchedStockChangeRequest?: PatchedStockChangeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStockUpdateResponse>(getVendorStockUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStockChangeRequest)
  }
);}





export const getVendorStockUpdateMutationKey = () => ['vendorStockUpdate'] as const;

export const getVendorStockUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStockUpdate>>, TError,VendorStockUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStockUpdate>>, TError,VendorStockUpdateMutationVariables, TContext> => {

const mutationKey = getVendorStockUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStockUpdate>>, VendorStockUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorStockUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStockUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStockUpdate>>>
    export type VendorStockUpdateMutationBody = PatchedStockChangeRequest | undefined
    export type VendorStockUpdateMutationError = unknown
    export type VendorStockUpdateMutationVariables = {uid: string;data?: PatchedStockChangeRequest}

    export const useVendorStockUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStockUpdate>>, TError,VendorStockUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStockUpdate>>,
        TError,
        VendorStockUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStockUpdateMutationOptions(options), queryClient);
    }
    export type vendorStockMovementsResponse200 = {
  data: StockMovement[]
  status: 200
}

export type vendorStockMovementsResponseSuccess = (vendorStockMovementsResponse200) & {
  headers: Headers;
};
;

export type vendorStockMovementsResponse = (vendorStockMovementsResponseSuccess)

export const getVendorStockMovementsUrl = (uid: string,) => {




  return `/api/v1/vendor/stock/${uid}/movements`
}

export const vendorStockMovements = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockMovementsResponse> => {

  return apiFetch<vendorStockMovementsResponse>(getVendorStockMovementsUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStockMovementsQueryKey = (uid: string,) => {
    return [
    `/api/v1/vendor/stock/${uid}/movements`
    ] as const;
    }


export const getVendorStockMovementsQueryOptions = <TData = Awaited<ReturnType<typeof vendorStockMovements>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockMovements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStockMovementsQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStockMovements>>> = ({ signal }) => vendorStockMovements(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStockMovements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStockMovementsQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStockMovements>>>
export type VendorStockMovementsQueryError = unknown


export function useVendorStockMovements<TData = Awaited<ReturnType<typeof vendorStockMovements>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockMovements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockMovements>>,
          TError,
          Awaited<ReturnType<typeof vendorStockMovements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockMovements<TData = Awaited<ReturnType<typeof vendorStockMovements>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockMovements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockMovements>>,
          TError,
          Awaited<ReturnType<typeof vendorStockMovements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockMovements<TData = Awaited<ReturnType<typeof vendorStockMovements>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockMovements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStockMovements<TData = Awaited<ReturnType<typeof vendorStockMovements>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockMovements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStockMovementsQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStockBulkResponse200 = {
  data: StockBulkResult
  status: 200
}

export type vendorStockBulkResponseSuccess = (vendorStockBulkResponse200) & {
  headers: Headers;
};
;

export type vendorStockBulkResponse = (vendorStockBulkResponseSuccess)

export const getVendorStockBulkUrl = () => {




  return `/api/v1/vendor/stock/bulk`
}

export const vendorStockBulk = async (stockBulkRequest: StockBulkRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockBulkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStockBulkResponse>(getVendorStockBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stockBulkRequest)
  }
);}





export const getVendorStockBulkMutationKey = () => ['vendorStockBulk'] as const;

export const getVendorStockBulkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStockBulk>>, TError,VendorStockBulkMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStockBulk>>, TError,VendorStockBulkMutationVariables, TContext> => {

const mutationKey = getVendorStockBulkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStockBulk>>, VendorStockBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorStockBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStockBulkMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStockBulk>>>
    export type VendorStockBulkMutationBody = StockBulkRequest
    export type VendorStockBulkMutationError = unknown
    export type VendorStockBulkMutationVariables = {data: StockBulkRequest}

    export const useVendorStockBulk = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStockBulk>>, TError,VendorStockBulkMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStockBulk>>,
        TError,
        VendorStockBulkMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStockBulkMutationOptions(options), queryClient);
    }
    export type vendorStockExportResponse200 = {
  data: string
  status: 200
}

export type vendorStockExportResponseSuccess = (vendorStockExportResponse200) & {
  headers: Headers;
};
;

export type vendorStockExportResponse = (vendorStockExportResponseSuccess)

export const getVendorStockExportUrl = () => {




  return `/api/v1/vendor/stock/export`
}

export const vendorStockExport = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockExportResponse> => {

  return apiFetch<vendorStockExportResponse>(getVendorStockExportUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStockExportQueryKey = () => {
    return [
    `/api/v1/vendor/stock/export`
    ] as const;
    }


export const getVendorStockExportQueryOptions = <TData = Awaited<ReturnType<typeof vendorStockExport>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStockExportQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStockExport>>> = ({ signal }) => vendorStockExport({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStockExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStockExportQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStockExport>>>
export type VendorStockExportQueryError = unknown


export function useVendorStockExport<TData = Awaited<ReturnType<typeof vendorStockExport>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockExport>>,
          TError,
          Awaited<ReturnType<typeof vendorStockExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockExport<TData = Awaited<ReturnType<typeof vendorStockExport>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockExport>>,
          TError,
          Awaited<ReturnType<typeof vendorStockExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockExport<TData = Awaited<ReturnType<typeof vendorStockExport>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStockExport<TData = Awaited<ReturnType<typeof vendorStockExport>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStockExportQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStockImportResponse200 = {
  data: StockImportResult
  status: 200
}

export type vendorStockImportResponseSuccess = (vendorStockImportResponse200) & {
  headers: Headers;
};
;

export type vendorStockImportResponse = (vendorStockImportResponseSuccess)

export const getVendorStockImportUrl = () => {




  return `/api/v1/vendor/stock/import`
}

export const vendorStockImport = async (stockImportRequest: StockImportRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockImportResponse> => {
    const formData = new FormData();
formData.append(`file`, stockImportRequest.file);
if(stockImportRequest.apply !== undefined) {
 formData.append(`apply`, stockImportRequest.apply.toString())
 }

  return apiFetch<vendorStockImportResponse>(getVendorStockImportUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getVendorStockImportMutationKey = () => ['vendorStockImport'] as const;

export const getVendorStockImportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStockImport>>, TError,VendorStockImportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStockImport>>, TError,VendorStockImportMutationVariables, TContext> => {

const mutationKey = getVendorStockImportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStockImport>>, VendorStockImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorStockImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStockImportMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStockImport>>>
    export type VendorStockImportMutationBody = StockImportRequest
    export type VendorStockImportMutationError = unknown
    export type VendorStockImportMutationVariables = {data: StockImportRequest}

    export const useVendorStockImport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStockImport>>, TError,VendorStockImportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStockImport>>,
        TError,
        VendorStockImportMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStockImportMutationOptions(options), queryClient);
    }
    export type vendorStockSummaryResponse200 = {
  data: StockSummary
  status: 200
}

export type vendorStockSummaryResponseSuccess = (vendorStockSummaryResponse200) & {
  headers: Headers;
};
;

export type vendorStockSummaryResponse = (vendorStockSummaryResponseSuccess)

export const getVendorStockSummaryUrl = () => {




  return `/api/v1/vendor/stock/summary`
}

export const vendorStockSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorStockSummaryResponse> => {

  return apiFetch<vendorStockSummaryResponse>(getVendorStockSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStockSummaryQueryKey = () => {
    return [
    `/api/v1/vendor/stock/summary`
    ] as const;
    }


export const getVendorStockSummaryQueryOptions = <TData = Awaited<ReturnType<typeof vendorStockSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStockSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStockSummary>>> = ({ signal }) => vendorStockSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStockSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStockSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStockSummary>>>
export type VendorStockSummaryQueryError = unknown


export function useVendorStockSummary<TData = Awaited<ReturnType<typeof vendorStockSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockSummary>>,
          TError,
          Awaited<ReturnType<typeof vendorStockSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockSummary<TData = Awaited<ReturnType<typeof vendorStockSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStockSummary>>,
          TError,
          Awaited<ReturnType<typeof vendorStockSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStockSummary<TData = Awaited<ReturnType<typeof vendorStockSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStockSummary<TData = Awaited<ReturnType<typeof vendorStockSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStockSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStockSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStoreRetrieveResponse200 = {
  data: StoreSettings
  status: 200
}

export type vendorStoreRetrieveResponseSuccess = (vendorStoreRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorStoreRetrieveResponse = (vendorStoreRetrieveResponseSuccess)

export const getVendorStoreRetrieveUrl = () => {




  return `/api/v1/vendor/store`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreRetrieveResponse> => {

  return apiFetch<vendorStoreRetrieveResponse>(getVendorStoreRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStoreRetrieveQueryKey = () => {
    return [
    `/api/v1/vendor/store`
    ] as const;
    }


export const getVendorStoreRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStoreRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStoreRetrieve>>> = ({ signal }) => vendorStoreRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStoreRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStoreRetrieve>>>
export type VendorStoreRetrieveQueryError = unknown


export function useVendorStoreRetrieve<TData = Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStoreRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorStoreRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStoreRetrieve<TData = Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStoreRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorStoreRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStoreRetrieve<TData = Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStoreRetrieve<TData = Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStoreRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStorePartialUpdateResponse200 = {
  data: StoreSettings
  status: 200
}

export type vendorStorePartialUpdateResponseSuccess = (vendorStorePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorStorePartialUpdateResponse = (vendorStorePartialUpdateResponseSuccess)

export const getVendorStorePartialUpdateUrl = () => {




  return `/api/v1/vendor/store`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStorePartialUpdate = async (patchedStoreUpdateRequest?: PatchedStoreUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStorePartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStorePartialUpdateResponse>(getVendorStorePartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStoreUpdateRequest)
  }
);}





export const getVendorStorePartialUpdateMutationKey = () => ['vendorStorePartialUpdate'] as const;

export const getVendorStorePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStorePartialUpdate>>, TError,VendorStorePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStorePartialUpdate>>, TError,VendorStorePartialUpdateMutationVariables, TContext> => {

const mutationKey = getVendorStorePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStorePartialUpdate>>, VendorStorePartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorStorePartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStorePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStorePartialUpdate>>>
    export type VendorStorePartialUpdateMutationBody = PatchedStoreUpdateRequest | undefined
    export type VendorStorePartialUpdateMutationError = unknown
    export type VendorStorePartialUpdateMutationVariables = {data?: PatchedStoreUpdateRequest}

    export const useVendorStorePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStorePartialUpdate>>, TError,VendorStorePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStorePartialUpdate>>,
        TError,
        VendorStorePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStorePartialUpdateMutationOptions(options), queryClient);
    }
    export type vendorStoreAddressesListResponse200 = {
  data: StoreAddress[]
  status: 200
}

export type vendorStoreAddressesListResponseSuccess = (vendorStoreAddressesListResponse200) & {
  headers: Headers;
};
;

export type vendorStoreAddressesListResponse = (vendorStoreAddressesListResponseSuccess)

export const getVendorStoreAddressesListUrl = () => {




  return `/api/v1/vendor/store/addresses`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreAddressesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreAddressesListResponse> => {

  return apiFetch<vendorStoreAddressesListResponse>(getVendorStoreAddressesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStoreAddressesListQueryKey = () => {
    return [
    `/api/v1/vendor/store/addresses`
    ] as const;
    }


export const getVendorStoreAddressesListQueryOptions = <TData = Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStoreAddressesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStoreAddressesList>>> = ({ signal }) => vendorStoreAddressesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStoreAddressesListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStoreAddressesList>>>
export type VendorStoreAddressesListQueryError = unknown


export function useVendorStoreAddressesList<TData = Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStoreAddressesList>>,
          TError,
          Awaited<ReturnType<typeof vendorStoreAddressesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStoreAddressesList<TData = Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStoreAddressesList>>,
          TError,
          Awaited<ReturnType<typeof vendorStoreAddressesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStoreAddressesList<TData = Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStoreAddressesList<TData = Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreAddressesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStoreAddressesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStoreAddressesCreateResponse201 = {
  data: StoreAddress[]
  status: 201
}

export type vendorStoreAddressesCreateResponseSuccess = (vendorStoreAddressesCreateResponse201) & {
  headers: Headers;
};
;

export type vendorStoreAddressesCreateResponse = (vendorStoreAddressesCreateResponseSuccess)

export const getVendorStoreAddressesCreateUrl = () => {




  return `/api/v1/vendor/store/addresses`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreAddressesCreate = async (storeAddressInputRequest: StoreAddressInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreAddressesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStoreAddressesCreateResponse>(getVendorStoreAddressesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(storeAddressInputRequest)
  }
);}





export const getVendorStoreAddressesCreateMutationKey = () => ['vendorStoreAddressesCreate'] as const;

export const getVendorStoreAddressesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesCreate>>, TError,VendorStoreAddressesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesCreate>>, TError,VendorStoreAddressesCreateMutationVariables, TContext> => {

const mutationKey = getVendorStoreAddressesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreAddressesCreate>>, VendorStoreAddressesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorStoreAddressesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreAddressesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreAddressesCreate>>>
    export type VendorStoreAddressesCreateMutationBody = StoreAddressInputRequest
    export type VendorStoreAddressesCreateMutationError = unknown
    export type VendorStoreAddressesCreateMutationVariables = {data: StoreAddressInputRequest}

    export const useVendorStoreAddressesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesCreate>>, TError,VendorStoreAddressesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreAddressesCreate>>,
        TError,
        VendorStoreAddressesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreAddressesCreateMutationOptions(options), queryClient);
    }
    export type vendorStoreAddressesUpdateResponse200 = {
  data: StoreAddress[]
  status: 200
}

export type vendorStoreAddressesUpdateResponseSuccess = (vendorStoreAddressesUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorStoreAddressesUpdateResponse = (vendorStoreAddressesUpdateResponseSuccess)

export const getVendorStoreAddressesUpdateUrl = (uid: string,) => {




  return `/api/v1/vendor/store/addresses/${uid}`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreAddressesUpdate = async (uid: string,
    storeAddressInputRequest: StoreAddressInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreAddressesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStoreAddressesUpdateResponse>(getVendorStoreAddressesUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(storeAddressInputRequest)
  }
);}





export const getVendorStoreAddressesUpdateMutationKey = () => ['vendorStoreAddressesUpdate'] as const;

export const getVendorStoreAddressesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesUpdate>>, TError,VendorStoreAddressesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesUpdate>>, TError,VendorStoreAddressesUpdateMutationVariables, TContext> => {

const mutationKey = getVendorStoreAddressesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreAddressesUpdate>>, VendorStoreAddressesUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorStoreAddressesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreAddressesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreAddressesUpdate>>>
    export type VendorStoreAddressesUpdateMutationBody = StoreAddressInputRequest
    export type VendorStoreAddressesUpdateMutationError = unknown
    export type VendorStoreAddressesUpdateMutationVariables = {uid: string;data: StoreAddressInputRequest}

    export const useVendorStoreAddressesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesUpdate>>, TError,VendorStoreAddressesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreAddressesUpdate>>,
        TError,
        VendorStoreAddressesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreAddressesUpdateMutationOptions(options), queryClient);
    }
    export type vendorStoreAddressesDeleteResponse204 = {
  data: void
  status: 204
}

export type vendorStoreAddressesDeleteResponseSuccess = (vendorStoreAddressesDeleteResponse204) & {
  headers: Headers;
};
;

export type vendorStoreAddressesDeleteResponse = (vendorStoreAddressesDeleteResponseSuccess)

export const getVendorStoreAddressesDeleteUrl = (uid: string,) => {




  return `/api/v1/vendor/store/addresses/${uid}`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreAddressesDelete = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreAddressesDeleteResponse> => {

  return apiFetch<vendorStoreAddressesDeleteResponse>(getVendorStoreAddressesDeleteUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorStoreAddressesDeleteMutationKey = () => ['vendorStoreAddressesDelete'] as const;

export const getVendorStoreAddressesDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesDelete>>, TError,VendorStoreAddressesDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesDelete>>, TError,VendorStoreAddressesDeleteMutationVariables, TContext> => {

const mutationKey = getVendorStoreAddressesDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreAddressesDelete>>, VendorStoreAddressesDeleteMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorStoreAddressesDelete(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreAddressesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreAddressesDelete>>>

    export type VendorStoreAddressesDeleteMutationError = unknown
    export type VendorStoreAddressesDeleteMutationVariables = {uid: string}

    export const useVendorStoreAddressesDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreAddressesDelete>>, TError,VendorStoreAddressesDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreAddressesDelete>>,
        TError,
        VendorStoreAddressesDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreAddressesDeleteMutationOptions(options), queryClient);
    }
    export type vendorStoreBankAccountsListResponse200 = {
  data: VendorBankAccount[]
  status: 200
}

export type vendorStoreBankAccountsListResponseSuccess = (vendorStoreBankAccountsListResponse200) & {
  headers: Headers;
};
;

export type vendorStoreBankAccountsListResponse = (vendorStoreBankAccountsListResponseSuccess)

export const getVendorStoreBankAccountsListUrl = () => {




  return `/api/v1/vendor/store/bank-accounts`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreBankAccountsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreBankAccountsListResponse> => {

  return apiFetch<vendorStoreBankAccountsListResponse>(getVendorStoreBankAccountsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorStoreBankAccountsListQueryKey = () => {
    return [
    `/api/v1/vendor/store/bank-accounts`
    ] as const;
    }


export const getVendorStoreBankAccountsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorStoreBankAccountsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>> = ({ signal }) => vendorStoreBankAccountsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorStoreBankAccountsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>>
export type VendorStoreBankAccountsListQueryError = unknown


export function useVendorStoreBankAccountsList<TData = Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStoreBankAccountsList>>,
          TError,
          Awaited<ReturnType<typeof vendorStoreBankAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStoreBankAccountsList<TData = Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorStoreBankAccountsList>>,
          TError,
          Awaited<ReturnType<typeof vendorStoreBankAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorStoreBankAccountsList<TData = Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorStoreBankAccountsList<TData = Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorStoreBankAccountsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorStoreBankAccountsCreateResponse201 = {
  data: VendorBankAccount[]
  status: 201
}

export type vendorStoreBankAccountsCreateResponseSuccess = (vendorStoreBankAccountsCreateResponse201) & {
  headers: Headers;
};
;

export type vendorStoreBankAccountsCreateResponse = (vendorStoreBankAccountsCreateResponseSuccess)

export const getVendorStoreBankAccountsCreateUrl = () => {




  return `/api/v1/vendor/store/bank-accounts`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreBankAccountsCreate = async (storeBankInputRequest: StoreBankInputRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreBankAccountsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStoreBankAccountsCreateResponse>(getVendorStoreBankAccountsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(storeBankInputRequest)
  }
);}





export const getVendorStoreBankAccountsCreateMutationKey = () => ['vendorStoreBankAccountsCreate'] as const;

export const getVendorStoreBankAccountsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsCreate>>, TError,VendorStoreBankAccountsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsCreate>>, TError,VendorStoreBankAccountsCreateMutationVariables, TContext> => {

const mutationKey = getVendorStoreBankAccountsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreBankAccountsCreate>>, VendorStoreBankAccountsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorStoreBankAccountsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreBankAccountsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreBankAccountsCreate>>>
    export type VendorStoreBankAccountsCreateMutationBody = StoreBankInputRequest
    export type VendorStoreBankAccountsCreateMutationError = unknown
    export type VendorStoreBankAccountsCreateMutationVariables = {data: StoreBankInputRequest}

    export const useVendorStoreBankAccountsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsCreate>>, TError,VendorStoreBankAccountsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreBankAccountsCreate>>,
        TError,
        VendorStoreBankAccountsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreBankAccountsCreateMutationOptions(options), queryClient);
    }
    export type vendorStoreBankAccountsDeleteResponse204 = {
  data: void
  status: 204
}

export type vendorStoreBankAccountsDeleteResponseSuccess = (vendorStoreBankAccountsDeleteResponse204) & {
  headers: Headers;
};
;

export type vendorStoreBankAccountsDeleteResponse = (vendorStoreBankAccountsDeleteResponseSuccess)

export const getVendorStoreBankAccountsDeleteUrl = (uid: string,) => {




  return `/api/v1/vendor/store/bank-accounts/${uid}`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreBankAccountsDelete = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreBankAccountsDeleteResponse> => {

  return apiFetch<vendorStoreBankAccountsDeleteResponse>(getVendorStoreBankAccountsDeleteUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVendorStoreBankAccountsDeleteMutationKey = () => ['vendorStoreBankAccountsDelete'] as const;

export const getVendorStoreBankAccountsDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsDelete>>, TError,VendorStoreBankAccountsDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsDelete>>, TError,VendorStoreBankAccountsDeleteMutationVariables, TContext> => {

const mutationKey = getVendorStoreBankAccountsDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreBankAccountsDelete>>, VendorStoreBankAccountsDeleteMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorStoreBankAccountsDelete(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreBankAccountsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreBankAccountsDelete>>>

    export type VendorStoreBankAccountsDeleteMutationError = unknown
    export type VendorStoreBankAccountsDeleteMutationVariables = {uid: string}

    export const useVendorStoreBankAccountsDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsDelete>>, TError,VendorStoreBankAccountsDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreBankAccountsDelete>>,
        TError,
        VendorStoreBankAccountsDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreBankAccountsDeleteMutationOptions(options), queryClient);
    }
    export type vendorStoreBankAccountsPrimaryResponse200 = {
  data: VendorBankAccount[]
  status: 200
}

export type vendorStoreBankAccountsPrimaryResponseSuccess = (vendorStoreBankAccountsPrimaryResponse200) & {
  headers: Headers;
};
;

export type vendorStoreBankAccountsPrimaryResponse = (vendorStoreBankAccountsPrimaryResponseSuccess)

export const getVendorStoreBankAccountsPrimaryUrl = (uid: string,) => {




  return `/api/v1/vendor/store/bank-accounts/${uid}/primary`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreBankAccountsPrimary = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreBankAccountsPrimaryResponse> => {

  return apiFetch<vendorStoreBankAccountsPrimaryResponse>(getVendorStoreBankAccountsPrimaryUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorStoreBankAccountsPrimaryMutationKey = () => ['vendorStoreBankAccountsPrimary'] as const;

export const getVendorStoreBankAccountsPrimaryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsPrimary>>, TError,VendorStoreBankAccountsPrimaryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsPrimary>>, TError,VendorStoreBankAccountsPrimaryMutationVariables, TContext> => {

const mutationKey = getVendorStoreBankAccountsPrimaryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreBankAccountsPrimary>>, VendorStoreBankAccountsPrimaryMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorStoreBankAccountsPrimary(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreBankAccountsPrimaryMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreBankAccountsPrimary>>>

    export type VendorStoreBankAccountsPrimaryMutationError = unknown
    export type VendorStoreBankAccountsPrimaryMutationVariables = {uid: string}

    export const useVendorStoreBankAccountsPrimary = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreBankAccountsPrimary>>, TError,VendorStoreBankAccountsPrimaryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreBankAccountsPrimary>>,
        TError,
        VendorStoreBankAccountsPrimaryMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreBankAccountsPrimaryMutationOptions(options), queryClient);
    }
    export type vendorStoreOnlineResponse200 = {
  data: StoreSettings
  status: 200
}

export type vendorStoreOnlineResponseSuccess = (vendorStoreOnlineResponse200) & {
  headers: Headers;
};
;

export type vendorStoreOnlineResponse = (vendorStoreOnlineResponseSuccess)

export const getVendorStoreOnlineUrl = () => {




  return `/api/v1/vendor/store/online`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorStoreOnline = async (storeOnlineRequest: StoreOnlineRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorStoreOnlineResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorStoreOnlineResponse>(getVendorStoreOnlineUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(storeOnlineRequest)
  }
);}





export const getVendorStoreOnlineMutationKey = () => ['vendorStoreOnline'] as const;

export const getVendorStoreOnlineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreOnline>>, TError,VendorStoreOnlineMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorStoreOnline>>, TError,VendorStoreOnlineMutationVariables, TContext> => {

const mutationKey = getVendorStoreOnlineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorStoreOnline>>, VendorStoreOnlineMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorStoreOnline(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorStoreOnlineMutationResult = NonNullable<Awaited<ReturnType<typeof vendorStoreOnline>>>
    export type VendorStoreOnlineMutationBody = StoreOnlineRequest
    export type VendorStoreOnlineMutationError = unknown
    export type VendorStoreOnlineMutationVariables = {data: StoreOnlineRequest}

    export const useVendorStoreOnline = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorStoreOnline>>, TError,VendorStoreOnlineMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorStoreOnline>>,
        TError,
        VendorStoreOnlineMutationVariables,
        TContext
      > => {
      return useMutation(getVendorStoreOnlineMutationOptions(options), queryClient);
    }
    export type vendorSupportCategoriesResponse200 = {
  data: TicketCategory[]
  status: 200
}

export type vendorSupportCategoriesResponseSuccess = (vendorSupportCategoriesResponse200) & {
  headers: Headers;
};
;

export type vendorSupportCategoriesResponse = (vendorSupportCategoriesResponseSuccess)

export const getVendorSupportCategoriesUrl = () => {




  return `/api/v1/vendor/support/categories`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const vendorSupportCategories = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorSupportCategoriesResponse> => {

  return apiFetch<vendorSupportCategoriesResponse>(getVendorSupportCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorSupportCategoriesQueryKey = () => {
    return [
    `/api/v1/vendor/support/categories`
    ] as const;
    }


export const getVendorSupportCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof vendorSupportCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorSupportCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorSupportCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorSupportCategories>>> = ({ signal }) => vendorSupportCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorSupportCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorSupportCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof vendorSupportCategories>>>
export type VendorSupportCategoriesQueryError = unknown


export function useVendorSupportCategories<TData = Awaited<ReturnType<typeof vendorSupportCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorSupportCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorSupportCategories>>,
          TError,
          Awaited<ReturnType<typeof vendorSupportCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorSupportCategories<TData = Awaited<ReturnType<typeof vendorSupportCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorSupportCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorSupportCategories>>,
          TError,
          Awaited<ReturnType<typeof vendorSupportCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorSupportCategories<TData = Awaited<ReturnType<typeof vendorSupportCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorSupportCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorSupportCategories<TData = Awaited<ReturnType<typeof vendorSupportCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorSupportCategories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorSupportCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorTaxClassesListResponse200 = {
  data: TaxClassRef[]
  status: 200
}

export type vendorTaxClassesListResponseSuccess = (vendorTaxClassesListResponse200) & {
  headers: Headers;
};
;

export type vendorTaxClassesListResponse = (vendorTaxClassesListResponseSuccess)

export const getVendorTaxClassesListUrl = () => {




  return `/api/v1/vendor/tax-classes`
}

/**
 * Active classes for the vendor product form.
 */
export const vendorTaxClassesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorTaxClassesListResponse> => {

  return apiFetch<vendorTaxClassesListResponse>(getVendorTaxClassesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorTaxClassesListQueryKey = () => {
    return [
    `/api/v1/vendor/tax-classes`
    ] as const;
    }


export const getVendorTaxClassesListQueryOptions = <TData = Awaited<ReturnType<typeof vendorTaxClassesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTaxClassesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorTaxClassesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorTaxClassesList>>> = ({ signal }) => vendorTaxClassesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorTaxClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorTaxClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorTaxClassesList>>>
export type VendorTaxClassesListQueryError = unknown


export function useVendorTaxClassesList<TData = Awaited<ReturnType<typeof vendorTaxClassesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTaxClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTaxClassesList>>,
          TError,
          Awaited<ReturnType<typeof vendorTaxClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTaxClassesList<TData = Awaited<ReturnType<typeof vendorTaxClassesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTaxClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTaxClassesList>>,
          TError,
          Awaited<ReturnType<typeof vendorTaxClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTaxClassesList<TData = Awaited<ReturnType<typeof vendorTaxClassesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTaxClassesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorTaxClassesList<TData = Awaited<ReturnType<typeof vendorTaxClassesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTaxClassesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorTaxClassesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorTeamListResponse200 = {
  data: TeamMember[]
  status: 200
}

export type vendorTeamListResponseSuccess = (vendorTeamListResponse200) & {
  headers: Headers;
};
;

export type vendorTeamListResponse = (vendorTeamListResponseSuccess)

export const getVendorTeamListUrl = () => {




  return `/api/v1/vendor/team`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorTeamList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<vendorTeamListResponse> => {

  return apiFetch<vendorTeamListResponse>(getVendorTeamListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorTeamListQueryKey = () => {
    return [
    `/api/v1/vendor/team`
    ] as const;
    }


export const getVendorTeamListQueryOptions = <TData = Awaited<ReturnType<typeof vendorTeamList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTeamList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorTeamListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorTeamList>>> = ({ signal }) => vendorTeamList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorTeamList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorTeamListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorTeamList>>>
export type VendorTeamListQueryError = unknown


export function useVendorTeamList<TData = Awaited<ReturnType<typeof vendorTeamList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTeamList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTeamList>>,
          TError,
          Awaited<ReturnType<typeof vendorTeamList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTeamList<TData = Awaited<ReturnType<typeof vendorTeamList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTeamList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTeamList>>,
          TError,
          Awaited<ReturnType<typeof vendorTeamList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTeamList<TData = Awaited<ReturnType<typeof vendorTeamList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTeamList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorTeamList<TData = Awaited<ReturnType<typeof vendorTeamList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTeamList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorTeamListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorTeamInviteResponse201 = {
  data: TeamMember[]
  status: 201
}

export type vendorTeamInviteResponseSuccess = (vendorTeamInviteResponse201) & {
  headers: Headers;
};
;

export type vendorTeamInviteResponse = (vendorTeamInviteResponseSuccess)

export const getVendorTeamInviteUrl = () => {




  return `/api/v1/vendor/team`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorTeamInvite = async (teamInviteRequest: TeamInviteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTeamInviteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorTeamInviteResponse>(getVendorTeamInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamInviteRequest)
  }
);}





export const getVendorTeamInviteMutationKey = () => ['vendorTeamInvite'] as const;

export const getVendorTeamInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTeamInvite>>, TError,VendorTeamInviteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorTeamInvite>>, TError,VendorTeamInviteMutationVariables, TContext> => {

const mutationKey = getVendorTeamInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorTeamInvite>>, VendorTeamInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorTeamInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorTeamInviteMutationResult = NonNullable<Awaited<ReturnType<typeof vendorTeamInvite>>>
    export type VendorTeamInviteMutationBody = TeamInviteRequest
    export type VendorTeamInviteMutationError = unknown
    export type VendorTeamInviteMutationVariables = {data: TeamInviteRequest}

    export const useVendorTeamInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTeamInvite>>, TError,VendorTeamInviteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorTeamInvite>>,
        TError,
        VendorTeamInviteMutationVariables,
        TContext
      > => {
      return useMutation(getVendorTeamInviteMutationOptions(options), queryClient);
    }
    export type vendorTeamUpdateResponse200 = {
  data: TeamMember[]
  status: 200
}

export type vendorTeamUpdateResponseSuccess = (vendorTeamUpdateResponse200) & {
  headers: Headers;
};
;

export type vendorTeamUpdateResponse = (vendorTeamUpdateResponseSuccess)

export const getVendorTeamUpdateUrl = (uid: string,) => {




  return `/api/v1/vendor/team/${uid}`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorTeamUpdate = async (uid: string,
    patchedTeamMemberUpdateRequest?: PatchedTeamMemberUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTeamUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<vendorTeamUpdateResponse>(getVendorTeamUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTeamMemberUpdateRequest)
  }
);}





export const getVendorTeamUpdateMutationKey = () => ['vendorTeamUpdate'] as const;

export const getVendorTeamUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTeamUpdate>>, TError,VendorTeamUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorTeamUpdate>>, TError,VendorTeamUpdateMutationVariables, TContext> => {

const mutationKey = getVendorTeamUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorTeamUpdate>>, VendorTeamUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  vendorTeamUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorTeamUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorTeamUpdate>>>
    export type VendorTeamUpdateMutationBody = PatchedTeamMemberUpdateRequest | undefined
    export type VendorTeamUpdateMutationError = unknown
    export type VendorTeamUpdateMutationVariables = {uid: string;data?: PatchedTeamMemberUpdateRequest}

    export const useVendorTeamUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTeamUpdate>>, TError,VendorTeamUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorTeamUpdate>>,
        TError,
        VendorTeamUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorTeamUpdateMutationOptions(options), queryClient);
    }
    export type vendorTeamResendResponse204 = {
  data: void
  status: 204
}

export type vendorTeamResendResponseSuccess = (vendorTeamResendResponse204) & {
  headers: Headers;
};
;

export type vendorTeamResendResponse = (vendorTeamResendResponseSuccess)

export const getVendorTeamResendUrl = (uid: string,) => {




  return `/api/v1/vendor/team/${uid}/resend`
}

/**
 * `needs = {"GET": code, "POST": code, …}`: the team-role permission each method requires.
 */
export const vendorTeamResend = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTeamResendResponse> => {

  return apiFetch<vendorTeamResendResponse>(getVendorTeamResendUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVendorTeamResendMutationKey = () => ['vendorTeamResend'] as const;

export const getVendorTeamResendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTeamResend>>, TError,VendorTeamResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorTeamResend>>, TError,VendorTeamResendMutationVariables, TContext> => {

const mutationKey = getVendorTeamResendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorTeamResend>>, VendorTeamResendMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  vendorTeamResend(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorTeamResendMutationResult = NonNullable<Awaited<ReturnType<typeof vendorTeamResend>>>

    export type VendorTeamResendMutationError = unknown
    export type VendorTeamResendMutationVariables = {uid: string}

    export const useVendorTeamResend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTeamResend>>, TError,VendorTeamResendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorTeamResend>>,
        TError,
        VendorTeamResendMutationVariables,
        TContext
      > => {
      return useMutation(getVendorTeamResendMutationOptions(options), queryClient);
    }
    export type vendorTicketsListResponse200 = {
  data: PaginatedTicketListList
  status: 200
}

export type vendorTicketsListResponseSuccess = (vendorTicketsListResponse200) & {
  headers: Headers;
};
;

export type vendorTicketsListResponse = (vendorTicketsListResponseSuccess)

export const getVendorTicketsListUrl = (params?: VendorTicketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/vendor/tickets?${stringifiedParams}` : `/api/v1/vendor/tickets`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const vendorTicketsList = async (params?: VendorTicketsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTicketsListResponse> => {

  return apiFetch<vendorTicketsListResponse>(getVendorTicketsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorTicketsListQueryKey = (params?: VendorTicketsListParams,) => {
    return [
    `/api/v1/vendor/tickets`, ...(params ? [params] : [])
    ] as const;
    }


export const getVendorTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof vendorTicketsList>>, TError = unknown>(params?: VendorTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorTicketsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorTicketsList>>> = ({ signal }) => vendorTicketsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof vendorTicketsList>>>
export type VendorTicketsListQueryError = unknown


export function useVendorTicketsList<TData = Awaited<ReturnType<typeof vendorTicketsList>>, TError = unknown>(
 params: undefined |  VendorTicketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTicketsList>>,
          TError,
          Awaited<ReturnType<typeof vendorTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTicketsList<TData = Awaited<ReturnType<typeof vendorTicketsList>>, TError = unknown>(
 params?: VendorTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTicketsList>>,
          TError,
          Awaited<ReturnType<typeof vendorTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTicketsList<TData = Awaited<ReturnType<typeof vendorTicketsList>>, TError = unknown>(
 params?: VendorTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorTicketsList<TData = Awaited<ReturnType<typeof vendorTicketsList>>, TError = unknown>(
 params?: VendorTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorTicketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorTicketsCreateResponse201 = {
  data: TicketDetail
  status: 201
}

export type vendorTicketsCreateResponseSuccess = (vendorTicketsCreateResponse201) & {
  headers: Headers;
};
;

export type vendorTicketsCreateResponse = (vendorTicketsCreateResponseSuccess)

export const getVendorTicketsCreateUrl = () => {




  return `/api/v1/vendor/tickets`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const vendorTicketsCreate = async (openRequest: OpenRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTicketsCreateResponse> => {
    const formData = new FormData();
formData.append(`category`, openRequest.category);
formData.append(`subject`, openRequest.subject);
formData.append(`body`, openRequest.body);
if(openRequest.order !== undefined) {
 formData.append(`order`, openRequest.order);
 }
if(openRequest.attachments !== undefined) {
 openRequest.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return apiFetch<vendorTicketsCreateResponse>(getVendorTicketsCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getVendorTicketsCreateMutationKey = () => ['vendorTicketsCreate'] as const;

export const getVendorTicketsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTicketsCreate>>, TError,VendorTicketsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorTicketsCreate>>, TError,VendorTicketsCreateMutationVariables, TContext> => {

const mutationKey = getVendorTicketsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorTicketsCreate>>, VendorTicketsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  vendorTicketsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof vendorTicketsCreate>>>
    export type VendorTicketsCreateMutationBody = OpenRequest
    export type VendorTicketsCreateMutationError = unknown
    export type VendorTicketsCreateMutationVariables = {data: OpenRequest}

    export const useVendorTicketsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTicketsCreate>>, TError,VendorTicketsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorTicketsCreate>>,
        TError,
        VendorTicketsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVendorTicketsCreateMutationOptions(options), queryClient);
    }
    export type vendorTicketsRetrieveResponse200 = {
  data: TicketDetail
  status: 200
}

export type vendorTicketsRetrieveResponseSuccess = (vendorTicketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type vendorTicketsRetrieveResponse = (vendorTicketsRetrieveResponseSuccess)

export const getVendorTicketsRetrieveUrl = (number: string,) => {




  return `/api/v1/vendor/tickets/${number}`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const vendorTicketsRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTicketsRetrieveResponse> => {

  return apiFetch<vendorTicketsRetrieveResponse>(getVendorTicketsRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorTicketsRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/vendor/tickets/${number}`
    ] as const;
    }


export const getVendorTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorTicketsRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorTicketsRetrieve>>> = ({ signal }) => vendorTicketsRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof vendorTicketsRetrieve>>>
export type VendorTicketsRetrieveQueryError = unknown


export function useVendorTicketsRetrieve<TData = Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTicketsRetrieve<TData = Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof vendorTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTicketsRetrieve<TData = Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorTicketsRetrieve<TData = Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorTicketsRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorTicketsAttachmentResponse200 = {
  data: Blob
  status: 200
}

export type vendorTicketsAttachmentResponseSuccess = (vendorTicketsAttachmentResponse200) & {
  headers: Headers;
};
;

export type vendorTicketsAttachmentResponse = (vendorTicketsAttachmentResponseSuccess)

export const getVendorTicketsAttachmentUrl = (number: string,
    media: string,) => {




  return `/api/v1/vendor/tickets/${number}/attachments/${media}`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const vendorTicketsAttachment = async (number: string,
    media: string, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTicketsAttachmentResponse> => {

  return apiFetch<vendorTicketsAttachmentResponse>(getVendorTicketsAttachmentUrl(number,media),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVendorTicketsAttachmentQueryKey = (number: string,
    media: string,) => {
    return [
    `/api/v1/vendor/tickets/${number}/attachments/${media}`
    ] as const;
    }


export const getVendorTicketsAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError = unknown>(number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVendorTicketsAttachmentQueryKey(number,media);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vendorTicketsAttachment>>> = ({ signal }) => vendorTicketsAttachment(number,media, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && media !== null && media !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VendorTicketsAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof vendorTicketsAttachment>>>
export type VendorTicketsAttachmentQueryError = unknown


export function useVendorTicketsAttachment<TData = Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTicketsAttachment>>,
          TError,
          Awaited<ReturnType<typeof vendorTicketsAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTicketsAttachment<TData = Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof vendorTicketsAttachment>>,
          TError,
          Awaited<ReturnType<typeof vendorTicketsAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVendorTicketsAttachment<TData = Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVendorTicketsAttachment<TData = Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vendorTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVendorTicketsAttachmentQueryOptions(number,media,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type vendorTicketsReplyResponse200 = {
  data: TicketDetail
  status: 200
}

export type vendorTicketsReplyResponseSuccess = (vendorTicketsReplyResponse200) & {
  headers: Headers;
};
;

export type vendorTicketsReplyResponse = (vendorTicketsReplyResponseSuccess)

export const getVendorTicketsReplyUrl = (number: string,) => {




  return `/api/v1/vendor/tickets/${number}/reply`
}

/**
 * Shared by the store (customer) and vendor (store member) endpoints.
 */
export const vendorTicketsReply = async (number: string,
    replyRequest: ReplyRequest, options?: Parameters<typeof apiFetch>[1]): Promise<vendorTicketsReplyResponse> => {
    const formData = new FormData();
formData.append(`body`, replyRequest.body);
if(replyRequest.is_internal_note !== undefined) {
 formData.append(`is_internal_note`, replyRequest.is_internal_note.toString())
 }
if(replyRequest.attachments !== undefined) {
 replyRequest.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return apiFetch<vendorTicketsReplyResponse>(getVendorTicketsReplyUrl(number),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getVendorTicketsReplyMutationKey = () => ['vendorTicketsReply'] as const;

export const getVendorTicketsReplyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTicketsReply>>, TError,VendorTicketsReplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof vendorTicketsReply>>, TError,VendorTicketsReplyMutationVariables, TContext> => {

const mutationKey = getVendorTicketsReplyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof vendorTicketsReply>>, VendorTicketsReplyMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  vendorTicketsReply(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VendorTicketsReplyMutationResult = NonNullable<Awaited<ReturnType<typeof vendorTicketsReply>>>
    export type VendorTicketsReplyMutationBody = ReplyRequest
    export type VendorTicketsReplyMutationError = unknown
    export type VendorTicketsReplyMutationVariables = {number: string;data: ReplyRequest}

    export const useVendorTicketsReply = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof vendorTicketsReply>>, TError,VendorTicketsReplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof vendorTicketsReply>>,
        TError,
        VendorTicketsReplyMutationVariables,
        TContext
      > => {
      return useMutation(getVendorTicketsReplyMutationOptions(options), queryClient);
    }
